import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 1,
  "data-testid": "ds-attendance-detail-error",
  class: "flex flex-col items-center justify-center py-16 gap-4 text-center bg-white"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-textPrimary font-bold text-lg" }, " Não foi possível carregar o registro de plantão. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-gray-500 text-sm mt-1",
  "data-testid": "ds-attendance-detail-error-message"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm mt-1" }, "Tente novamente ou volte para a lista de aprovações.", -1)
const _hoisted_5 = { class: "flex flex-col sm:flex-row gap-3 mt-2" }
const _hoisted_6 = {
  key: 2,
  class: "text-textPrimary text-left bg-white"
}
const _hoisted_7 = { class: "flex flex-col gap-4 mt-4" }
const _hoisted_8 = {
  "data-testid": "ds-attendance-audit-header-strip",
  class: "flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-lightGray30 bg-lightGray30/30 px-3 py-2"
}
const _hoisted_9 = { class: "text-textPrimary bg-white border border-lightGray30 py-1 px-2 rounded-lg text-sm" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_12 = { class: "flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-neutral50" }
const _hoisted_13 = { class: "font-bold text-textPrimary" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "ml-auto flex items-center gap-2" }
const _hoisted_16 = {
  key: 0,
  "data-testid": "ds-attendance-replacement-notice",
  class: "flex items-start gap-3 rounded-lg border border-primary10 bg-primary5/40 p-3 text-left"
}
const _hoisted_17 = {
  class: "w-full min-w-0 flex flex-col",
  "data-testid": "ds-attendance-audit-viewer"
}
const _hoisted_18 = { class: "w-full flex flex-col gap-4 text-left min-w-0" }
const _hoisted_19 = {
  key: 0,
  "data-testid": "ds-attendance-station-changed-alert",
  class: "flex flex-col gap-2 rounded-lg border border-alert bg-alert/10 p-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "w-fit rounded bg-alert px-2 py-[2px] text-[11px] font-bold uppercase leading-4 tracking-wide text-white" }, " Requer atenção ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-[18px] text-textPrimary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Plantão alterado após auditoria:"),
  /*#__PURE__*/_createTextVNode(" a vaga/plantão desta escala foi criada, alterada ou excluída depois do início da auditoria. Revise os lançamentos conciliados antes de aprovar. ")
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-1" }, "Justificativa de reprovação", -1)
const _hoisted_24 = { class: "text-sm mt-0.5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-1" }, "Observação"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm mt-0.5" }, "Não informada")
], -1)
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-2" }, " Preencha as informações da folha de monitoramento ", -1)
const _hoisted_28 = {
  key: 0,
  class: "mb-3 flex items-start gap-2 rounded-lg border border-primary10 bg-primary5/40 p-2 text-xs text-primary40",
  "data-testid": "prefill-mirror-note"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "✨", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-2" }, "Validação da folha", -1)
const _hoisted_31 = {
  key: 0,
  class: "text-sm text-amber-700 mb-3",
  "data-testid": "unmatched-rows-hint"
}
const _hoisted_32 = {
  key: 4,
  class: "rounded-lg border border-amber-300 bg-amber-50 p-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-amber-800 mb-1" }, "Justificativa pendente", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-amber-700" }, " O escalista enviou uma justificativa para as divergências encontradas. Avalie abaixo. ", -1)
const _hoisted_35 = {
  key: 0,
  class: "flex gap-3 mt-3"
}
const _hoisted_36 = {
  key: 5,
  class: "flex justify-end"
}
const _hoisted_37 = {
  key: 6,
  class: "text-xs text-neutral50 mt-2",
  "data-testid": "sheet-conference-gate-reason"
}
const _hoisted_38 = {
  key: 7,
  class: "m-0 mt-2 text-sm text-neutral50",
  role: "status",
  "data-testid": "sheet-audit-no-permission"
}
const _hoisted_39 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3 mt-2" }
const _hoisted_40 = {
  class: "rounded-lg border border-lightGray30",
  "data-testid": "ds-attendance-audit-drawer"
}
const _hoisted_41 = ["aria-expanded"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, "Histórico e comentários", -1)
const _hoisted_43 = {
  class: "text-neutral50",
  "aria-hidden": "true"
}
const _hoisted_44 = {
  key: 0,
  id: "ds-attendance-audit-drawer-content",
  class: "flex flex-col gap-4 border-t border-lightGray30 p-3"
}

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { getApiErrorMessage, getApiErrorStatus, isTimeoutError } from '@/utils/apiError'
import { mdiAlertCircleOutline } from '@mdi/js'
import Network from '@/Network'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import StepPreview from '@/components/designSystem/modals/AttendanceUploadModal/StepPreview.vue'
import DsAttendanceConciliationModal from './DsAttendanceConciliationModal.vue'
import type {
  SheetColumn,
  ColumnType,
  SheetColumnCustomEditor,
  SheetColumnMenuItem
} from '@/components/designSystem/Cards/attendanceSheet.types'
import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'
import DsAttendanceHistoryCard, {
  HistoryEvent
} from '@/components/designSystem/Cards/DsAttendanceHistoryCard.vue'
import CommentsForm from '@/components/designSystem/Inputs/CommentsForm.vue'
import DsAttendanceHistoryCardSkeleton from '@/components/designSystem/Skeleton/DsAttendanceHistoryCardSkeleton.vue'
import CommentsFormSkeleton from '@/components/designSystem/Skeleton/CommentsFormSkeleton.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import {
  DSAttendanceStatus,
  DSAttendanceMonitoringType,
  ImageState,
  IMAGE_STATE_LABEL,
  REJECTION_REASON_LABELS,
  RejectionReason,
  ValidationStatus,
  ConciliationType,
  PrefillOutcome,
  SourceType,
  AUDIT_IN_PROGRESS_REASON_OPTIONS,
  getRejectionReasonOptionsByModality,
  ContainerKind
} from '@/constants/ds-attendance.constants'
import DsAttendanceActivityAudit from './DsAttendanceActivityAudit.vue'
import {
  NO_AUDIT_PERMISSION_MESSAGE,
  useCanAuditAttendance
} from '../composables/useCanAuditAttendance'
import { useCanRevertValidation } from '../composables/useCanRevertValidation'
import { useCanEmitAttendance } from '../composables/useCanEmitAttendance'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import DsAttendanceSheetMirror from './DsAttendanceSheetMirror.vue'
import { indexEligibilityByDoctorStation } from '@/constants/payment-eligibility.constants'
import type { PaymentEligibilityView } from '@/types/payment-eligibility.types'
import UnidentifiedCoverageMirrorNotice from './UnidentifiedCoverageMirrorNotice.vue'
import DsAttendancePrefillEmptyState from './DsAttendancePrefillEmptyState.vue'
import DsAttendancePrefillErrorState from './DsAttendancePrefillErrorState.vue'
import DsAttendanceAutoApprovedPanel from './DsAttendanceAutoApprovedPanel.vue'
import DsAttendanceQualityWarnings from './DsAttendanceQualityWarnings.vue'
import DsAttendanceAutoApprovalCriteriaModal from './DsAttendanceAutoApprovalCriteriaModal.vue'
import DsAttendanceSheetConferenceModal from './DsAttendanceSheetConferenceModal.vue'
import {
  NO_SCHEDULE_EXPECTED_LABEL,
  buildNoScheduleExpectedTooltip
} from '../utils/prefill-empty-state'
import {
  buildMirrorRows,
  createExtraRow,
  isRowEdited,
  pendingConferenceRows,
  resolveRowState,
  tallyOutcomes,
  toConciliateRows,
  hasUnsavedSignatureStamp,
  hasUnsavedPageNumber,
  rowsMissingSignatureStamp,
  type MirrorRow
} from '../utils/prefill-mirror'
import DsAttendanceRejectModal from './DsAttendanceRejectModal.vue'
import DsAttendanceRevertModal from './DsAttendanceRevertModal.vue'
import DsAttendancePreviousSheets from './DsAttendancePreviousSheets.vue'
import DsAttendanceNewSheetModal from './DsAttendanceNewSheetModal.vue'
import { newSheetActionFor } from '../utils/new-sheet'
import { useOpenAttendanceContainer } from '../composables/useOpenAttendanceContainer'
import DsAttendanceLegOverwriteModal from './DsAttendanceLegOverwriteModal.vue'
import DsAttendanceUnmatchedApprovalModal from './DsAttendanceUnmatchedApprovalModal.vue'
import {
  countUnmatchedRows,
  unmatchedRowsMessage,
  useUnmatchedApprovalGate
} from '../composables/useUnmatchedApprovalGate'
import { useLegOverwriteApproval } from '../composables/useLegOverwriteApproval'
import DsAttendanceJustificationModal from './DsAttendanceJustificationModal.vue'
import DsAttendanceDiscardEmptyRowsModal from './DsAttendanceDiscardEmptyRowsModal.vue'
import DsAttendanceSwitchTemplateModal from './DsAttendanceSwitchTemplateModal.vue'
import DsAttendanceUnsavedExitModal from './DsAttendanceUnsavedExitModal.vue'
import {
  classifyRow,
  createEmptyRow,
  missingCellKeys,
  type RowStatus
} from '../utils/sheet-row-classification'
import {
  MAX_SHEET_ROWS,
  MIN_SHEET_ROWS,
  rowLimitReason,
  minRowLimitReason,
  isAtRowLimit
} from '@/components/designSystem/Cards/sheetRowLimits'
import { normalizeColumnKey, resolveSuggestionColumns } from '../utils/doctor-suggestion-columns'
import { createDoctorSuggestionCellEditor } from '../utils/doctor-suggestion-cell-editor'
import {
  resolveColumnActionState,
  firstFilledValue,
  applyToColumn,
  clearColumn,
  setColumnCheckbox
} from '../utils/column-action'
import AttendanceSheetCard from '@/components/designSystem/Cards/AttendanceSheetCard.vue'
import DsAttendanceSheetActionBar from './DsAttendanceSheetActionBar.vue'
import type {
  DSAttendanceContainerDetailResponse,
  DSAttendanceConciliateRowResult,
  DSAttendancePrefillEmptyReason,
  DSAttendanceUnidentifiedCoverageStation
} from '@/Network/Types/Responses/DsAttendancePolicyResponses'
import type {
  DSAttendanceApprovalMode,
  DSAttendanceAutoApprovalCriterion,
  DSAttendanceAutoApprovalFields
} from '@/Network/Types/Responses/DsAttendanceAuditResponses'
import {
  APPROVAL_MODE_LABELS,
  AUTO_APPROVAL_CRITERIA_AUDIT_ACTION,
  manualReviewReasonLabel
} from '@/constants/ds-attendance-auto-approval.constants'
import {
  isMagnifierBlockedByRotation as magnifierBlockedByRotation,
  readMagnifierPreference,
  writeMagnifierPreference
} from '../utils/sheet-magnifier'
import { clampPage, isValidPage, resolveRowPage } from '../utils/sheet-page-map'
import { resolveDivergenceReason } from '../utils/conciliation-divergence'
import { mapAuditTrailToHistoryEvents } from '@/utils/dsAttendanceHistory'
import { useNextContainer } from '../composables/useNextContainer'
import {
  approvalsQueueBreadcrumbs,
  approvalsQueueLocation
} from '@/modules/company/Approvals/Hub/queues'

type AuditContainerDetail = DSAttendanceContainerDetailResponse & DSAttendanceAutoApprovalFields

const NOT_INFORMED = 'Não informado'
const DOCTOR_NAME_COLUMN_WIDTH = '260'

type SheetModel = {
  id: number
  label: string
  columns: SheetColumn[]
  defaultRow: Record<string, string | boolean>
  rowCount: number
}

const SHEET_CONFERENCE_GATE_REASON =
  'A conferência da folha é sempre exigida antes de avançar para a auditoria — mesmo que o motor tenha conciliado 100% dos horários.'

/**
 * Pacote 2026-09-10 — assinatura e carimbo por linha no espelho, com o mesmo bloqueio da
 * grade clássica: caixa desmarcada em linha em uso trava o avanço (o backend também
 * rejeita a conciliação nesse caso). As caixas nascem marcadas e o operador desmarca o que
 * faltar na folha, então o gate só aparece depois de uma desmarcação. Linhas "não consta
 * na folha" e extras em branco não contam. Sem colunas na modalidade app externo.
 */
const SIGNATURE_STAMP_GATE_REASON =
  'Marque a conferência de assinatura e carimbo de entrada e de saída em todas as linhas da folha (ou marque a linha como "Não consta na folha") para avançar para a auditoria.'

const PREFILL_ERROR_FALLBACK = 'Não foi possível pré-preencher a folha com a escala prevista.'

/**
 * RF do mockup (pin 1) — selecionar o modelo de folha JÁ traz as linhas da escala prevista.
 * Idempotente no backend: reentrar na tela ou reselecionar o mesmo modelo não duplica entry.
 *
 * Enquanto o endpoint não estiver publicado no ambiente, a tela cai no fluxo clássico de
 * digitação em silêncio — pré-preencher é aceleração, não requisito para auditar a folha.
 */
const VIEWER_MIN_HEIGHT_PX = 320
const DEFAULT_VIEWER_HEIGHT_PX = 620

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceAwaitingAudit',
  emits: ["close", "startValidation", "advanceToReconciliation"],
  setup(__props, { emit }) {



const router = useRouter()
const route = useRoute()
const headerStore = useHeaderStore()

const canAuditAttendance = useCanAuditAttendance()
// Justificativa e comentário são escritas do emissor: o perfil Extrator só lê.
const canEmit = useCanEmitAttendance()

const canRevertValidation = useCanRevertValidation()

/**
 * Fase 2 (§6): o detalhe ganha `approvalMode` e `manualReviewReason` por interseção, num
 * arquivo de tipos separado — a frente da fila edita `DsAttendancePolicyResponses.ts` em
 * paralelo e o aditivo aqui não conflita com o dela.
 *
 * O `kind` da F2, ao contrário, vive no próprio `DSAttendanceContainerDetailResponse`: ele é
 * lido também fora desta tela.
 */
const details = ref<AuditContainerDetail | null>(null)

/** F2/M3 — o único ramo desta tela: `ATIVIDADE` é outra tela, o resto continua aqui. */
const isActivityKind = computed(() => details.value?.kind === ContainerKind.ATIVIDADE)

const isExternalApp = computed(
  () => details.value?.monitoringType === DSAttendanceMonitoringType.EXTERNAL_APP
)

const attendanceId = computed(() => String(route.params.attendanceId))

const fileName = computed(() => details.value?.sheetFilename || 'Folha-de-monitoramento.pdf')

const sentBy = computed(() => details.value?.submittedBy?.name ?? NOT_INFORMED)
const validatedBy = computed(() => details.value?.reviewedBy?.name ?? NOT_INFORMED)

/** RN-02 — data de referência única do container, fonte do pré-preenchimento (RF-01). */
const referenceDate = computed(() => details.value?.referenceDate ?? '')

const { flags } = useFeatureFlags()

/**
 * PRD 32 atrás de uma única flag; desligada, a tela é a anterior à US-01. O gating tem três
 * partes: esta alavanca de classificação (`prefillDate`), a engine de grade do
 * `AttendanceSheetCard` (nativa quando desligada, jspreadsheet quando ligada) e quatro
 * guardas de exibição — `sheetRowErrors`, `handleAdvanceClick`, o rodapé do motivo e o
 * tooltip do botão.
 */
const isSheetV2 = flags.enabledDsAttendanceSheetV2

/**
 * A alavanca de classificação: sem `referenceDate`, `createEmptyRow` deixa as colunas de data
 * vazias e a exceção da RN-03 em `classifyRow` desaparece — a classificação degenera
 * exatamente na completude anterior ao PRD 32 (linha vazia ou toda preenchida).
 */
const prefillDate = computed(() => (isSheetV2 ? referenceDate.value : ''))

const date = computed(() => {
  if (!details.value?.referenceDate) return 'Não informada'
  try {
    return format(new Date(details.value.referenceDate + 'T00:00:00'), 'dd/MM/yyyy', {
      locale: ptBR
    })
  } catch {
    // fallback intencional: erro local de formatação; mantém referenceDate
    return details.value.referenceDate
  }
})

const unit = computed(() => details.value?.healthUnit?.name ?? 'Não informada')
const schedules = computed(() => details.value?.schedule?.name ?? 'Não informada')
const shifts = computed(() => {
  const list = details.value?.shifts
  if (!list || list.length === 0) return NOT_INFORMED
  return list.map((s: { name: string }) => s.name).join(', ')
})
const imageState = computed(() => {
  const state = details.value?.imageState
  return state ? (IMAGE_STATE_LABEL[state as ImageState] ?? state) : 'Não informado'
})

/**
 * Fase 1 do fluxo de auditoria — tri-estado: `undefined` é backend anterior à fase 1 e não
 * acende chip nenhum; só `false` diz "a escala não prevê plantão nesta data/turnos".
 */
const hasScheduleExpected = computed(() => details.value?.hasScheduleExpected)

const noScheduleExpectedTooltip = computed(() =>
  buildNoScheduleExpectedTooltip({
    scheduleName: schedules.value,
    date: date.value,
    shifts: shifts.value
  })
)

const fileUrl = ref<string | undefined>(undefined)
const isLoadingEvidence = ref(true)

const openSheet = () => {
  if (fileUrl.value) window.open(fileUrl.value, '_blank')
}

const fileType = computed(() => {
  const name = details.value?.sheetFilename
  if (!name) return undefined
  if (name.toLowerCase().endsWith('.pdf')) return 'application/pdf'
  return undefined
})
const isLoadingHistory = ref(true)
const historyEvents = ref<HistoryEvent[]>([])

/** BUG-PP-02 — getById falhou: bloco de erro substitui o corpo inteiro da tela. */
const hasLoadError = ref(false)

/** Mensagem específica do service (permissão, rede, timeout...) exibida no bloco de erro. */
const loadErrorMessage = ref<string | null>(null)

/**
 * BUG-PP-02 (nit) — enquanto uma tentativa (mount ou retry) está em curso, sinaliza
 * para desabilitar o botão "Tentar novamente" e evitar disparo duplo.
 */
const isRetrying = ref(false)

/** Busca o container. `false` no retorno sinaliza falha — quem chama decide o curto-circuito. */
async function loadContainerDetails(id: string): Promise<boolean> {
  try {
    const response = await Network.dsAttendance.getById(id)
    details.value = response
    return true
  } catch (error) {
    console.error('Erro ao buscar detalhes do container:', error)
    const fallback = 'Não foi possível carregar os detalhes do registro de presença.'
    loadErrorMessage.value = getApiErrorMessage(error, fallback)
    notifyError(error, fallback)
    return false
  }
}

/**
 * Apontamento 2 (vídeo 03/09) — o painel "Histórico" não recarregava depois do "Desfazer":
 * a trilha ganhava o evento no backend e a tela seguia mostrando a lista do carregamento
 * inicial. Extraído para ser rechamado por qualquer ação que grave auditoria (desfazer,
 * conferência da folha, "não consta na folha", substituição de médico).
 */
/**
 * Fase 2 §6.4 — o vetor de critérios que o motor gravou em `newValues.criteria` do evento
 * `CONTAINER_AUTO_APPROVED`. Ausente (backend anterior, ou container aprovado antes da
 * coluna), o modal cai no texto estático dos seis critérios.
 */
function extractAutoApprovalCriteria(
  items: Array<{ actionType: string; newValues: Record<string, unknown> | null }>
): DSAttendanceAutoApprovalCriterion[] {
  const event = [...items]
    .reverse()
    .find((item) => item.actionType === AUTO_APPROVAL_CRITERIA_AUDIT_ACTION)
  const criteria = event?.newValues?.criteria
  if (!Array.isArray(criteria)) return []
  return criteria.filter(
    (criterion): criterion is DSAttendanceAutoApprovalCriterion =>
      typeof criterion === 'object' && criterion !== null && 'key' in criterion
  )
}

async function loadHistory(id: string): Promise<void> {
  try {
    const response = await Network.dsAttendance.getAuditTrail(id)
    historyEvents.value = mapAuditTrailToHistoryEvents(response.data)
    autoApprovalCriteria.value = extractAutoApprovalCriteria(response.data)
  } catch (error) {
    // Antes só o console sabia: o card de histórico ficava vazio como se o registro
    // não tivesse eventos, sem distinguir "sem histórico" de "falhou ao buscar".
    console.error('Erro ao buscar histórico do container:', error)
    notifyError(error, 'Não foi possível carregar o histórico do registro de presença.')
  } finally {
    isLoadingHistory.value = false
  }
}

/** Recarrega a trilha do container atual — usado pelas ações que gravam auditoria. */
async function refreshHistory(): Promise<void> {
  await loadHistory(attendanceId.value)
}

/** Frente B §6 — selo por plantão no espelho. Apoio, nunca bloqueio: falha só apaga o selo. */
const eligibilityByDoctorStation = ref<Record<number, PaymentEligibilityView>>({})

async function loadPaymentEligibility(id: string): Promise<void> {
  eligibilityByDoctorStation.value = {}
  if (!flags.enabledPaymentEligibility) return
  try {
    const items = await Network.dsAttendance.getContainerPaymentEligibility(id)
    // "Aprovar e abrir o próximo" troca o registro na mesma instância: a resposta que chega
    // depois da troca é do container anterior e não pode pintar o selo do novo.
    if (id !== attendanceId.value) return
    eligibilityByDoctorStation.value = indexEligibilityByDoctorStation(items ?? [])
  } catch (error) {
    console.warn('[DsAttendance] elegibilidade por plantão indisponível; espelho sem selo', error)
  }
}

async function loadSecondaryData(id: string): Promise<void> {
  await Promise.allSettled([
    loadHistory(id),
    loadPaymentEligibility(id),

    Network.dsAttendance
      .downloadEvidenceFile(id)
      .then((blob) => {
        fileUrl.value = URL.createObjectURL(blob)
      })
      .catch((error) => {
        // Endpoint `blob`: com o unwrap no service, o motivo real (evidência removida,
        // sem permissão) finalmente chega aqui em vez do texto fixo.
        console.error('Erro ao baixar evidência do container:', error)
        notifyError(error, 'Não foi possível carregar o arquivo de evidência.')
        fileUrl.value = undefined
      })
      .finally(() => {
        isLoadingEvidence.value = false
      }),

    Network.dsAttendance
      .getRejectionReasons(details.value?.monitoringType ?? undefined)
      .then(({ reasons }) => {
        rejectionReasonOptions.value = reasons.map((r: string) => ({
          title: REJECTION_REASON_LABELS[r as RejectionReason] ?? r,
          value: r
        }))
      })
      .catch((e) => {
        // fallback intencional: a lista de motivos tem equivalente local por modalidade,
        // então a reprovação segue possível — falhar aqui só empobreceria as opções.
        console.warn('Fallback: usando motivos locais de reprovação.', e)
        rejectionReasonOptions.value = getRejectionReasonOptionsByModality(
          details.value?.monitoringType
        )
      })
  ])
}

/**
 * BUG-PP-02 — quando o container falha, as chamadas secundárias (histórico,
 * evidência, motivos de reprovação) NÃO disparam: hoje elas seguiam disparando
 * mesmo sem `details`, gerando toasts extras sobre uma tela que já vai virar
 * o bloco de erro. `loadAll` é reutilizada pelo retry.
 */
async function loadAll(): Promise<void> {
  const id = attendanceId.value
  const loaded = await loadContainerDetails(id)

  if (!loaded) {
    hasLoadError.value = true
    return
  }

  loadErrorMessage.value = null

  // Só limpa o erro DEPOIS de confirmar sucesso — limpar antes (mesmo que só até o
  // getById responder) reabre a janela do próprio bug: o corpo normal renderiza com os
  // fallbacks "Não informado(a)" por um instante enquanto a nova tentativa está em voo.
  hasLoadError.value = false

  /**
   * F2/M3 — container de Registro de Atividade: quem renderiza é
   * `DsAttendanceActivityAudit.vue`, que busca o que precisa. As chamadas secundárias daqui
   * são todas sobre uma FOLHA (`evidence-file`, motivos por modalidade) e só produziriam
   * toasts de erro sobre uma tela que nem está montada.
   */
  if (isActivityKind.value) return

  await loadSecondaryData(id)
}

/** BUG-PP-02 (nit) — `isRetrying` bloqueia clique duplo; `hasLoadError` só é tocado por `loadAll`. */
async function retryLoad(): Promise<void> {
  isRetrying.value = true
  try {
    await loadAll()
  } finally {
    isRetrying.value = false
  }
}

function goToApprovals(): void {
  router.push(approvalsQueueLocation('attendance'))
}

onMounted(() => {
  headerStore.setTitle(
    'Auditoria de Folha de Ponto',
    'Valide a transcrição e concilie o registro',
    approvalsQueueBreadcrumbs('attendance')
  )
})

/**
 * A carga inicial vira promessa porque os hooks abaixo só valem para a tela de FOLHA: quem
 * decide é `kind`, que só existe depois do `getById`. Sem esperar, o pai registrava atalhos
 * e buscava o "próximo da fila" por cima de uma tela que nem é dele (I14).
 */
let initialLoad: Promise<void> | null = null

onMounted(() => {
  initialLoad = loadAll()
})

onMounted(() => window.addEventListener('beforeunload', handleBeforeUnload))

/** Eixo 4: atalho da ação primária e descoberta do próximo da fila (falha ⇒ sem botão). */
onMounted(async () => {
  await initialLoad
  if (isActivityKind.value) return
  window.addEventListener('keydown', handleApproveShortcut)
  nextContainerId.value = await fetchNextId(attendanceId.value)
})

/** Cara-crachá V1: preferência da lupa, altura inicial da folha e o atalho `L`. */
onMounted(async () => {
  await initialLoad
  if (isActivityKind.value) return
  isMagnifierOn.value = readMagnifierPreference()
  viewerHeightPx.value = resolveInitialViewerHeight()
  window.addEventListener('keydown', handleMagnifierShortcut)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload)
  window.removeEventListener('keydown', handleMagnifierShortcut)
  window.removeEventListener('keydown', handleApproveShortcut)
  stopViewerResize()
  if (fileUrl.value?.startsWith('blob:')) {
    URL.revokeObjectURL(fileUrl.value)
  }
})

const isApproved = computed(() => route.name === 'DsAttendanceApproved')
const isRejected = computed(() => details.value?.status === DSAttendanceStatus.REJECTED)
const canReject = computed(
  () =>
    details.value !== null &&
    [DSAttendanceStatus.PENDING_AUDIT, DSAttendanceStatus.AUDIT_IN_PROGRESS].includes(
      currentStatus.value
    )
)

const rejectionReasonOptions = ref<Array<{ title: string; value: string }>>(
  getRejectionReasonOptionsByModality(details.value?.monitoringType)
)
const auditInProgressReason = ref<string | null>(null)
const isReverting = ref(false)
const currentStatus = computed(() => {
  if (isApproved.value) return DSAttendanceStatus.APPROVED
  if (isRejected.value) return DSAttendanceStatus.REJECTED
  return (details.value?.status as DSAttendanceStatus) ?? DSAttendanceStatus.PENDING_AUDIT
})

function handleClose() {
  emit('close')
  router.push(approvalsQueueLocation('attendance'))
}

const isRevertModalOpen = ref(false)

async function executeRevert(justification: string) {
  try {
    isReverting.value = true
    await Network.dsAttendance.revertValidation(attendanceId.value, { justification })
    toast.success('Validação revertida com sucesso.')
    isRevertModalOpen.value = false
    handleClose()
  } catch (error) {
    // `error instanceof Error ? message : fallback` era um funil caseiro: vazava o texto
    // técnico de um TypeError. `notifyError` usa o funil canônico do `getApiErrorMessage`.
    notifyError(error, 'Não foi possível reverter a validação do registro.')
  } finally {
    isReverting.value = false
  }
}

// --- Nova folha em registro reprovado (rejected-sheet-resubmission, CA1–CA5) ---
const { openContainer } = useOpenAttendanceContainer()
const isNewSheetModalOpen = ref(false)
const isSubmittingNewSheet = ref(false)
// #3072: a nova folha é do emissor (time de Escalas), não só da Auditoria.
const newSheetAction = computed(() => newSheetActionFor(details.value, canEmit.value))

function openReplacement(): void {
  const id = details.value?.replacementContainerId
  // Sem status: o substituto pode já estar em auditoria ou aprovado — a rota vem do status real.
  if (id) void openContainer(id)
}

async function executeNewSheet(payload: { file: File; justification: string }): Promise<void> {
  try {
    isSubmittingNewSheet.value = true
    await Network.dsAttendance.submitNewSheet(
      attendanceId.value,
      payload.file,
      payload.justification
    )
    toast.success('Nova folha enviada. O registro voltou para Aguardando Auditoria.')
    isNewSheetModalOpen.value = false
    // REJECTED e PENDING_AUDIT usam a mesma rota: recarrega no lugar. A conciliação foi
    // zerada no servidor e a folha é outra — o mesmo reset da troca de registro (blob,
    // visualizador, espelho, conciliação), senão página/rotação da folha recusada valem
    // para a nova e o visualizador fica sem spinner até o download.
    resetContainerScopedState()
    await loadAll()
  } catch (error) {
    notifyError(error, 'Não foi possível enviar a nova folha.')
  } finally {
    isSubmittingNewSheet.value = false
  }
}

// --- Justificativa de divergências (US10) ---
const isSubmitJustificationModalOpen = ref(false)
const isRejectJustificationModalOpen = ref(false)
const isProcessingJustification = ref(false)

async function handleSubmitJustification(justification: string) {
  try {
    isProcessingJustification.value = true
    await Network.dsAttendance.submitJustification(attendanceId.value, { justification })
    toast.success('Justificativa enviada com sucesso.')
    isSubmitJustificationModalOpen.value = false
    handleClose()
  } catch (error) {
    notifyError(error, 'Não foi possível enviar a justificativa.')
  } finally {
    isProcessingJustification.value = false
  }
}

async function handleAcceptJustification() {
  try {
    isProcessingJustification.value = true
    await Network.dsAttendance.acceptJustification(attendanceId.value)
    toast.success('Justificativa aceita com sucesso.')
    handleClose()
  } catch (error) {
    notifyError(error, 'Não foi possível aceitar a justificativa.')
  } finally {
    isProcessingJustification.value = false
  }
}

async function handleRejectJustification(justification: string) {
  try {
    isProcessingJustification.value = true
    await Network.dsAttendance.rejectJustification(attendanceId.value, { justification })
    toast.success('Justificativa rejeitada.')
    isRejectJustificationModalOpen.value = false
    handleClose()
  } catch (error) {
    notifyError(error, 'Não foi possível rejeitar a justificativa.')
  } finally {
    isProcessingJustification.value = false
  }
}

const rotation = ref(0)
const zoom = ref(1)

const toast = useToast()
const { notifyError } = useErrorToast()

const isValidating = ref(false)
const isConciliating = ref(false)
const hasConciliationStarted = ref(false)
const isConciliationModalOpen = ref(false)
const conciliationRows = ref<DSAttendanceConciliateRowResult[]>([])

/**
 * QW-01/28-06 — linha já veio `CONCILIATED`+`AUTOMATIC` na resposta de `/conciliate`
 * (SINGLE_MATCH auto-confirmado server-side, planos 28-02/28-03). Nunca inferido no
 * cliente — exige os dois campos vindos do backend (T-28-06-01).
 */
function isPreConfirmedConciliationRow(row: DSAttendanceConciliateRowResult): boolean {
  return (
    row.validationStatus === ValidationStatus.CONCILIATED &&
    row.conciliationType === ConciliationType.AUTOMATIC
  )
}

/** Linhas que já chegaram resolvidas do backend — exibidas com badge + "Desfazer", fora da
 * fila de perguntas Sim/Não do modal. */
const preConfirmedConciliationRows = computed(() =>
  conciliationRows.value.filter(isPreConfirmedConciliationRow)
)

/** Fila efetivamente iterada pelo modal (MULTIPLE_MATCHES/NO_MATCH e SINGLE_MATCH que não
 * veio pré-confirmado, ou que foi revertido via "Desfazer"). */
const pendingConciliationRows = computed(() =>
  conciliationRows.value.filter((row) => !isPreConfirmedConciliationRow(row))
)

const undoingAutomaticConciliationEntryId = ref<number | null>(null)

/**
 * QW-01/28-06 — "Desfazer" de uma linha pré-confirmada: reaproveita o mesmo endpoint/gate já
 * auditado no backend (28-03, `AUTOMATIC_CONCILIATION_REVERSED`), sem lógica de auditoria nova
 * no front (T-28-06-02). Após sucesso, a linha muda de status localmente e passa a fazer parte
 * de `pendingConciliationRows` — reabre para revisão manual no modal.
 */
async function handleUndoAutomaticConciliation(entryId: number) {
  if (undoingAutomaticConciliationEntryId.value !== null) return
  undoingAutomaticConciliationEntryId.value = entryId

  try {
    await Network.dsAttendance.confirmConciliation(attendanceId.value, {
      entries: [
        {
          entryId,
          validationStatus: ValidationStatus.DIVERGENT,
          divergenceReason: 'Revertido manualmente pelo auditor'
        }
      ]
    })
    const row = conciliationRows.value.find((r) => r.entryId === entryId)
    if (row) {
      row.validationStatus = ValidationStatus.DIVERGENT
      row.conciliationType = null
    }
    // Apontamento 2 — o desfazer grava `AUTOMATIC_CONCILIATION_REVERSED` na trilha; sem
    // este refresh o painel "Histórico" ficava desatualizado até um reload da página.
    await refreshHistory()
    toast.success('Conciliação automática desfeita — revise a linha manualmente.')
  } catch (error) {
    // `refreshHistory` não relança (o `loadHistory` avisa por conta própria): o que chega
    // aqui é a falha do `confirmConciliation`, com a mensagem do backend quando houver.
    notifyError(error, 'Não foi possível desfazer a conciliação automática. Tente novamente.')
  } finally {
    undoingAutomaticConciliationEntryId.value = null
  }
}

watch(isConciliationModalOpen, (open) => {
  if (!open && !hasConciliationBeenConfirmed.value) {
    hasConciliationStarted.value = false
  }
})

const isConciliationDone = ref(false)
const hasConciliationBeenConfirmed = ref(false)
const validationStatus = ref<string | null>(null)
const validationObservation = ref('')
const viewRows = ref<Record<string, unknown>[]>([])
const rejectionReason = ref<string | null>(null)
const isRejectModalOpen = ref(false)
const isSaving = ref(false)

/**
 * Eixo 4 da discovery 2026-09-11 — "Aprovar e abrir o próximo".
 *
 * O próximo é resolvido UMA vez ao abrir a tela e guardado em `nextContainerId` — é ele que
 * decide se o botão extra aparece e é ele que a navegação usa. Reconsultar depois de aprovar
 * devolveria o primeiro id da fila (o registro atual acabou de sair dela), que não é o que
 * estava logo depois deste; a consulta só acontece se não houver id guardado. Sem próximo — ou
 * com backend anterior à fase 2, que não tem a rota — o botão não aparece e a aprovação volta
 * para a lista como hoje.
 */
const nextContainerId = ref<number | null>(null)
const hasNextContainer = computed(() => nextContainerId.value !== null)
const isGoingToNext = ref(false)
const { fetchNextId, goToNext } = useNextContainer()

/**
 * Guarda de foco compartilhada pelos atalhos de teclado da tela: nenhum atalho age enquanto o
 * auditor está digitando (comentário, nome do médico, CRM, justificativa).
 */
function isTypingTarget(target: EventTarget | null): boolean {
  const element = target as HTMLElement | null
  const tag = element?.tagName
  return (
    tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || element?.isContentEditable === true
  )
}

/** Mesma regra do botão "Salvar validação" — extraída para o atalho não divergir do clique. */
const isSaveValidationDisabled = computed(
  () =>
    validationStatus.value === null ||
    (validationStatus.value === 'AUDITORIA_EM_PROGRESSO' && !auditInProgressReason.value) ||
    isSaving.value
)

/** RF-07 (#2115) — expõe `undo`/`canUndo` do jspreadsheet para o botão "Desfazer". */
const sheetCardRef = ref<InstanceType<typeof AttendanceSheetCard> | null>(null)

/** Linhas que a conciliação deixou "Sem correspondência" (web#2336). */
const unmatchedRowsCount = computed(() => countUnmatchedRows(viewRows.value))

// Aprovar com linha sem correspondência pede confirmação antes (minhaescala-product#81).
const unmatchedApprovalGate = useUnmatchedApprovalGate()
const isUnmatchedApprovalOpen = unmatchedApprovalGate.isOpen

const viewColumns = computed<SheetColumn[]>(() => [
  { key: 'conciliation', label: 'Conciliação', type: 'status', width: '140px' },
  ...sheetColumns.value
])

const sheetColumns = ref<SheetColumn[]>([])

const sheetRows = ref<Record<string, string | boolean>[]>([])

const KNOWN_COLUMN_MAP: Record<string, string> = {
  nome_do_medico: 'rawDoctorName',
  crm: 'rawCrm',
  entrada: 'checkinReal',
  saida: 'checkoutReal',
  'ass._e_carimbo_entrada': 'hasDoctorSignature',
  'ass._e_carimbo_saida': 'hasDoctorStamp'
}

/**
 * RF-03/RF-04 (#2111) — colunas de CRM/nome do modelo atual, na ordem em que aparecem.
 * Existe só atrás da flag: engine `native` (flag desligada) nunca usa `columnEditors`.
 */
const autocompleteColumns = computed(() =>
  isSheetV2 ? resolveSuggestionColumns(sheetColumns.value, KNOWN_COLUMN_MAP) : []
)

/**
 * RF-03/RF-04/RN-07 (#2111) — um editor customizado do jspreadsheet por coluna elegível,
 * cada um fechado sobre o índice da coluna par (para o cruzamento) quando ela existe.
 */
const sheetColumnEditors = computed<Record<string, SheetColumnCustomEditor>>(() => {
  const columns = autocompleteColumns.value
  const editors: Record<string, SheetColumnCustomEditor> = {}

  for (const column of columns) {
    const paired = columns.find((other) => other.key !== column.key)
    const pairedIndex = paired ? sheetColumns.value.findIndex((c) => c.key === paired.key) : -1

    editors[column.key] = createDoctorSuggestionCellEditor(
      column.field,
      paired && pairedIndex >= 0 ? { index: pairedIndex, field: paired.field } : null,
      () => attendanceId.value
    )
  }

  return editors
})

const TIME_FIELDS = new Set(['checkinReal', 'checkoutReal'])
const BOOLEAN_FIELDS = new Set(['hasDoctorSignature', 'hasDoctorStamp'])

function toISODateTime(time: string, referenceDate: string): string {
  const localDate = new Date(`${referenceDate}T${time}:00`)
  return localDate.toISOString()
}

function detectColumnType(label: string): ColumnType {
  const l = label
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
  if (l === 'data' || l.startsWith('data ')) return 'date'
  if (['assinatura', 'ass.', 'carimbo'].some((p) => l.includes(p))) return 'checkbox'
  if (['entrada', 'saida', 'jornada', 'inicio', 'fim'].some((p) => l.includes(p))) return 'time'
  return 'text'
}

/** Largura de domínio (px) da coluna de nome do médico — ver o comentário em `sheetModels`. */
const REQUIRED_CHECKBOX_COLUMNS: { after: string; label: string }[] = [
  { after: 'entrada', label: 'Ass. e Carimbo Entrada' },
  { after: 'saida', label: 'Ass. e Carimbo Saída' }
]

const sheetModels = computed(() =>
  (details.value?.sheetTemplates ?? []).map((template) => {
    const columns: SheetColumn[] = (template.columns ?? []).map((rawLabel) => {
      const label = typeof rawLabel === 'string' ? rawLabel : String(rawLabel)
      return {
        key: label.toLowerCase().replace(/\s+/g, '_'),
        label,
        type: detectColumnType(label)
      }
    })

    if (!isExternalApp.value) {
      for (const req of REQUIRED_CHECKBOX_COLUMNS) {
        const key = req.label.toLowerCase().replace(/\s+/g, '_')
        if (!columns.some((c) => c.key === key)) {
          const afterIndex = columns.findIndex((c) => c.key === req.after)
          const insertAt = afterIndex >= 0 ? afterIndex + 1 : columns.length
          columns.splice(insertAt, 0, { key, label: req.label, type: 'checkbox' })
        }
      }
    }

    /**
     * A coluna de nome do médico é a única de conteúdo longo do modelo — no default de
     * `text` (140px) ela truncava nomes completos, e com `table-layout: fixed` na grade o
     * conteúdo não empurra a coluna. A identificação reusa `resolveSuggestionColumns` de
     * propósito: é o **mesmo mapa** que leva a coluna ao payload de conciliação
     * (`doctor-suggestion-columns.ts`), nunca uma heurística nova de label. CRM fica no
     * default; modelo sem coluna de nome do médico simplesmente não recebe nada.
     */
    const doctorNameColumnKey = resolveSuggestionColumns(columns, KNOWN_COLUMN_MAP).find(
      (column) => column.field === 'name'
    )?.key
    const doctorNameColumn = columns.find((column) => column.key === doctorNameColumnKey)
    if (doctorNameColumn) doctorNameColumn.width = DOCTOR_NAME_COLUMN_WIDTH

    const defaultRow = createEmptyRow(columns, prefillDate.value)
    return {
      id: template.id,
      label: template.name,
      columns,
      defaultRow,
      rowCount: template.rowCount
    }
  })
)

const selectedSheetModel = ref<SheetModel | null>(null)

watch(
  sheetModels,
  (models) => {
    if (models.length > 0 && !selectedSheetModel.value) {
      selectedSheetModel.value = models[0]
      applySheetModel(models[0])
    }
  },
  { immediate: true }
)

/**
 * RN-09/RF-12 (#2119) — a tabela nasce com 1 linha, qualquer que seja o modelo de folha
 * aplicado; o modelo só dimensiona colunas (RN-09 já vigente). Só atrás de `isSheetV2`:
 * a flag desligada preserva o dimensionamento por `model.rowCount` de hoje.
 */
function applySheetModel(model: SheetModel) {
  sheetColumns.value = model.columns
  const rowCount = isSheetV2 ? 1 : model.rowCount
  sheetRows.value = Array.from({ length: rowCount }, () => ({ ...model.defaultRow }))

  // ESP-02/29-04 (pin 1 do mockup) — a grade nunca mais nasce vazia: escolher o modelo
  // pede o espelho da escala ao backend. Só durante a validação: no carregamento da tela o
  // primeiro modelo é aplicado automaticamente, e criar entries aí seria efeito colateral
  // de simplesmente abrir o registro.
  if (isSheetV2 && isValidating.value) void runPrefill(model.id)
}

/** RN-09/RF-12 — gate de "Adicionar linha", com o motivo no rodapé e em tooltip (RN-11). */
const canAddRow = computed(() => !isAtRowLimit(sheetRows.value.length, MAX_SHEET_ROWS))
const addRowReason = computed(() => (canAddRow.value ? undefined : rowLimitReason(MAX_SHEET_ROWS)))

/**
 * RN-09/RN-11 — o gate de "Excluir última linha" vem do próprio card (contagem da grade),
 * não de `sheetRows`: sem modelo de folha selecionado a tela mantém `sheetRows` vazio
 * enquanto a grade já mostra 1 linha.
 */
const deleteRowReason = computed(() =>
  sheetCardRef.value?.canDeleteRow ? undefined : minRowLimitReason(MIN_SHEET_ROWS)
)

/** RN-03 — estado derivado do conteúdo atual, recalculado a cada edição. */
const rowStatuses = computed<RowStatus[]>(() =>
  sheetRows.value.map((row) => classifyRow(row, sheetColumns.value, prefillDate.value))
)

/** Índices das linhas em uso, na mesma ordem em que entram no payload de conciliação. */
const rowsInUseIndexes = computed(() =>
  rowStatuses.value.flatMap((status, index) => (status === 'empty' ? [] : [index]))
)

const hasRowsInUse = computed(() => rowsInUseIndexes.value.length > 0)

/**
 * Frente E/Q21 — linhas cujos horários são obrigatórios de jornada na grade: as em uso ou,
 * com a folha ainda em branco, a primeira (é por ela que a transcrição começa).
 */
const journeyRowIndexes = computed(() => (hasRowsInUse.value ? rowsInUseIndexes.value : [0]))

/**
 * RF-07 (#2115) — trocar o modelo é direto sem nenhuma linha em uso; com alguma, pede
 * confirmação porque reconstrói as colunas e descarta o histórico junto com a estrutura
 * antiga (não é desfazível). O critério é `hasRowsInUse` (RN-03), não flag desligada —
 * a confirmação só existe atrás de `isSheetV2`, então a flag desligada preserva a troca
 * direta de hoje.
 */
const isSwitchTemplateModalOpen = ref(false)
const pendingSheetModel = ref<SheetModel | null>(null)

function handleSheetModelSelection(model: SheetModel) {
  if (model.id === selectedSheetModel.value?.id) return
  sheetCardRef.value?.commitPendingEdit()
  if (isSheetV2 && hasRowsInUse.value) {
    pendingSheetModel.value = model
    isSwitchTemplateModalOpen.value = true
    return
  }
  selectedSheetModel.value = model
  applySheetModel(model)
}

function confirmSwitchSheetModel() {
  if (pendingSheetModel.value) {
    selectedSheetModel.value = pendingSheetModel.value
    applySheetModel(pendingSheetModel.value)
  }
  pendingSheetModel.value = null
  isSwitchTemplateModalOpen.value = false
}

function cancelSwitchSheetModel() {
  pendingSheetModel.value = null
  isSwitchTemplateModalOpen.value = false
}
const emptyRowCount = computed(() => rowStatuses.value.length - rowsInUseIndexes.value.length)
const hasPartialRow = computed(() => rowStatuses.value.some((status) => status === 'partial'))

/** RF-06 — o texto de apoio do item habilitado, o mesmo do protótipo pinado (D-13/#13). */
function buildApplyHint(column: SheetColumn): string | undefined {
  const value = firstFilledValue(sheetRows.value, column, prefillDate.value)
  if (value === null) return undefined
  return `Replica "${String(value)}" — o valor da primeira célula preenchida — nas células vazias das linhas em uso.`
}

/**
 * RF-06/RN-03/RN-11 (#2113) — o item único do menu `▾` de cada coluna, derivado do
 * conteúdo atual das linhas em uso — nunca de foco ou seleção. `null`/`undefined` só
 * para colunas fora do modo `edit` (view/status), que não chegam a chamar esta função.
 */
function getColumnMenuItem(columnKey: string): SheetColumnMenuItem | undefined {
  const column = sheetColumns.value.find((c) => c.key === columnKey)
  if (!column) return undefined

  const state = resolveColumnActionState(
    column,
    sheetRows.value,
    rowsInUseIndexes.value,
    prefillDate.value
  )
  switch (state.kind) {
    case 'disabled':
      return {
        label: column.type === 'checkbox' ? 'Marcar coluna' : 'Aplicar à coluna',
        disabled: true,
        reason: state.reason,
        computeNewRows: (rows) => rows
      }
    case 'apply':
      return {
        label: 'Aplicar à coluna',
        disabled: false,
        hint: buildApplyHint(column),
        computeNewRows: (rows) =>
          applyToColumn(rows, column, rowsInUseIndexes.value, prefillDate.value)
      }
    case 'clear':
      return {
        label: 'Limpar coluna',
        disabled: false,
        computeNewRows: (rows) =>
          clearColumn(rows, column, rowsInUseIndexes.value, prefillDate.value)
      }
    case 'markAll':
      return {
        label: 'Marcar coluna',
        disabled: false,
        computeNewRows: (rows) => setColumnCheckbox(rows, column, rowsInUseIndexes.value, true)
      }
    case 'unmarkAll':
      return {
        label: 'Desmarcar coluna',
        disabled: false,
        computeNewRows: (rows) => setColumnCheckbox(rows, column, rowsInUseIndexes.value, false)
      }
  }
}

/** RF-02 — erro de validação nas células que faltam, exibido só em linha parcial. */
const sheetRowErrors = computed<Record<number, string[]>>(() => {
  if (!isSheetV2) return {}
  const errors: Record<number, string[]> = {}
  rowStatuses.value.forEach((status, index) => {
    if (status === 'partial') {
      errors[index] = missingCellKeys(sheetRows.value[index], sheetColumns.value)
    }
  })
  return errors
})

/**
 * RF-02 + RN-11 — motivo específico do bloqueio do avanço, exibido em dois lugares:
 * rodapé da tabela e tooltip no próprio botão. `null` significa avanço liberado.
 */
const classicAdvanceBlockReason = computed(() => {
  if (sheetColumns.value.length === 0) {
    return 'Selecione um modelo de folha para preencher a transcrição.'
  }
  if (rowsInUseIndexes.value.length === 0) {
    return 'Preencha ao menos uma linha da folha para avançar para a conciliação.'
  }
  if (hasPartialRow.value) {
    return 'Complete as linhas destacadas ou deixe-as vazias para avançar para a conciliação.'
  }
  return null
})

/**
 * ESP-02/29-04, decisão 7 — com o espelho na tela o único bloqueio é a conferência da
 * folha, exigida SEMPRE, mesmo que o motor tenha conciliado 100% dos horários: o motor
 * confere horário × escala, o humano atesta a folha física. Nenhum bypass.
 */
const mirrorRowsMissingSignatureStamp = computed(() =>
  isExternalApp.value ? [] : rowsMissingSignatureStamp(mirrorRows.value)
)

const advanceBlockReason = computed(() => {
  if (hasPrefillMirror.value) {
    if (mirrorRowsMissingSignatureStamp.value.length > 0) return SIGNATURE_STAMP_GATE_REASON
    return hasSheetConference.value ? null : SHEET_CONFERENCE_GATE_REASON
  }
  return classicAdvanceBlockReason.value
})

const isSheetComplete = computed(() => advanceBlockReason.value === null)

/** O motivo só vira tooltip no botão enquanto ele é o de avançar para a conciliação. */
const advanceTooltip = computed(() => (isValidating.value ? advanceBlockReason.value : null))

/**
 * No espelho o passo seguinte é a AUDITORIA (a conciliação acontece depois da conferência da
 * folha, no mesmo clique) — daí o rótulo diferente do fluxo clássico de digitação.
 */
const advanceButtonLabel = computed(() => {
  if (!isValidating.value) return 'Iniciar validação'
  return hasPrefillMirror.value ? 'Avançar para auditoria' : 'Avançar para conciliação'
})

// ==========================================================================
// ESPELHO DA ESCALA + CONFERÊNCIA DA FOLHA (ESP-02/29-04, mockup 05)
// ==========================================================================

const mirrorRows = ref<MirrorRow[]>([])
/**
 * Fase 1 do fluxo de auditoria — por que o espelho veio vazio. `null` cobre dois casos que
 * a tela trata igual: prefill com linhas, e backend anterior à fase 1 (silêncio).
 */
const prefillEmptyReason = ref<DSAttendancePrefillEmptyReason | null>(null)
/** Contagem devolvida pelo prefill; guardada para telemetria/depuração da marcação. */
const prefillExpectedDoctorStations = ref<number | null>(null)
const prefillUnidentifiedCount = ref(0)
const prefillUnidentifiedStations = ref<DSAttendanceUnidentifiedCoverageStation[]>([])
/**
 * F0-c (spec 2026-09-12, §1.c) — falha transitória do prefill. Enquanto preenchido, a grade
 * clássica de digitação fica fora da tela: o backend pode ter commitado as linhas e digitar
 * por cima duplica a folha.
 */
const prefillError = ref<{ message: string; canRetry: boolean } | null>(null)
/** Falhas consecutivas; a partir da segunda o escape "Digitar sem espelho" aparece. */
const prefillFailureCount = ref(0)
/** O operador escolheu explicitamente digitar sem espelho (D6: nada bloqueia). */
const userForcedClassic = ref(false)
const isPrefilling = ref(false)
const isMirrorSaving = ref(false)
const isSheetConferenceModalOpen = ref(false)
const hasSheetConference = ref(false)

/** A grade do espelho só substitui a de digitação quando o prefill devolveu linhas. */
const hasPrefillMirror = computed(() => mirrorRows.value.length > 0)
const hasPrefillError = computed(() => prefillError.value !== null)
/**
 * A grade clássica de digitação só pode nascer sem espelho E sem erro pendente — ou depois
 * de o operador pedir o escape explícito.
 */
const showClassicSheetGrid = computed(
  () => !hasPrefillMirror.value && (!hasPrefillError.value || userForcedClassic.value)
)
const isMirrorBusy = computed(() => isPrefilling.value || isMirrorSaving.value)
const canAddMirrorRow = computed(() => mirrorRows.value.length < MAX_SHEET_ROWS)
const pendingConferenceCount = computed(() => pendingConferenceRows(mirrorRows.value).length)
const mirrorTally = computed(() => tallyOutcomes(mirrorRows.value))
const prefillNote = computed(() => {
  const born = mirrorRows.value.filter((row) => row.isPrefillBorn).length
  const linhas = born === 1 ? 'linha pré-preenchida' : 'linhas pré-preenchidas'
  return `${born} ${linhas} com a escala prevista deste turno. Nada foi digitado — ajuste só o que a folha física mostrar diferente.`
})

const sheetConferenceSubtitle = computed(() =>
  [`Folha #${attendanceId.value}`, date.value, schedules.value, shifts.value]
    .filter((part) => part && part !== NOT_INFORMED)
    .join(' · ')
)

/** Status HTTP de backend que ainda não publicou a rota do espelho — fallback silencioso. */
const PREFILL_UNAVAILABLE_STATUSES = [404, 405, 501]
async function runPrefill(templateId: number): Promise<void> {
  isPrefilling.value = true
  prefillError.value = null
  try {
    const response = await Network.dsAttendance.prefillEntries(attendanceId.value, { templateId })
    mirrorRows.value = buildMirrorRows(response.entries ?? [])
    selectedMirrorIndex.value = null
    // O motivo só vale quando não há linhas; com espelho preenchido não há nada a explicar.
    prefillEmptyReason.value = mirrorRows.value.length === 0 ? (response.emptyReason ?? null) : null
    prefillExpectedDoctorStations.value = response.expectedDoctorStations ?? null
    prefillUnidentifiedCount.value = response.unidentifiedCoverageCount ?? 0
    prefillUnidentifiedStations.value = response.unidentifiedCoverageStations ?? []
    hasSheetConference.value = false
    prefillFailureCount.value = 0
    userForcedClassic.value = false
    if (mirrorRows.value.length > 0) await refreshHistory()
    // Espelho vazio COM motivo também gera evento na trilha (0 linhas) — vale recarregar.
    else if (prefillEmptyReason.value) await refreshHistory()
  } catch (error) {
    handlePrefillFailure(error)
  } finally {
    isPrefilling.value = false
  }
}

function handlePrefillFailure(error: unknown): void {
  const status = getApiErrorStatus(error)
  // Backend anterior à fase 1 (404/405/501): fallback silencioso para a grade clássica.
  if (status && PREFILL_UNAVAILABLE_STATUSES.includes(status)) {
    mirrorRows.value = []
    prefillEmptyReason.value = null
    prefillExpectedDoctorStations.value = null
    prefillUnidentifiedCount.value = 0
    prefillUnidentifiedStations.value = []
    console.warn('Espelho da escala indisponível neste ambiente — seguindo na digitação.', error)
    return
  }
  // F0-c: NÃO zerar `mirrorRows`. O que já está na tela continua válido, e o backend pode
  // ter commitado as linhas mesmo com o cliente abortando por timeout — apagar a grade é
  // justamente o que leva o operador a digitar tudo de novo e duplicar a folha.
  prefillFailureCount.value += 1
  prefillError.value = { message: buildPrefillErrorMessage(error), canRetry: true }
  // Com o espelho ainda montado o estado de erro não é renderizado (a grade vale mais que
  // o aviso); o toast evita que a falha passe em silêncio.
  if (hasPrefillMirror.value) {
    notifyError(error, PREFILL_ERROR_FALLBACK)
  }
}

/**
 * O timeout merece texto próprio: a transação do backend segue e commita mesmo depois de o
 * cliente desistir, então "tentar de novo" é literalmente como ver o resultado.
 */
function buildPrefillErrorMessage(error: unknown): string {
  if (isTimeoutError(error) || getApiErrorStatus(error) === 504) {
    return 'A geração do espelho demorou mais que o esperado. Ela pode ter terminado no servidor — clique em Tentar novamente para ver o resultado.'
  }
  return getApiErrorMessage(error, PREFILL_ERROR_FALLBACK)
}

/** Retry do estado de erro: sem modelo selecionado não há o que pedir ao backend. */
function retryPrefill(): void {
  const templateId = selectedSheetModel.value?.id
  if (templateId === undefined || templateId === null) return
  void runPrefill(templateId)
}

/**
 * RN-10 aplicada ao espelho — o que se perde ao sair sem avançar: horário editado inline e
 * linha extra digitada. Marcar ausente e substituir médico não entram: essas já foram
 * gravadas no backend no próprio clique.
 */
const hasUnsavedMirrorEdits = computed(() =>
  mirrorRows.value.some(
    (row) =>
      isRowEdited(row) ||
      hasUnsavedSignatureStamp(row) ||
      hasUnsavedPageNumber(row) ||
      (row.entryId === null && (row.doctorName.trim() !== '' || row.crm.trim() !== ''))
  )
)

/** O critério de "tem trabalho não enviado", qualquer que seja a grade na tela. */
const hasUnsavedSheetWork = computed(() =>
  hasPrefillMirror.value ? hasUnsavedMirrorEdits.value : hasRowsInUse.value
)

function patchMirrorRow(index: number, patch: Partial<MirrorRow>) {
  const row = mirrorRows.value[index]
  if (!row) return
  mirrorRows.value = mirrorRows.value.map((current, i) =>
    i === index ? { ...current, ...patch } : current
  )
}

function handleMirrorCell(payload: {
  index: number
  field: keyof MirrorRow
  value: string | boolean
}) {
  patchMirrorRow(payload.index, { [payload.field]: payload.value } as Partial<MirrorRow>)
}

/**
 * Autocomplete do PRD32 na linha extra: escolher a sugestão preenche nome e CRM
 * juntos, num único patch — meia identidade na tela seria pior que nenhuma.
 */
function handleMirrorSelectDoctor(payload: { index: number; doctorName: string; crm: string }) {
  patchMirrorRow(payload.index, { doctorName: payload.doctorName, crm: payload.crm })
}

/** Linha extra: está na folha física sem previsão na escala (decisão 2, segunda metade). */
function handleMirrorAddRow() {
  if (!canAddMirrorRow.value) return
  mirrorRows.value = [...mirrorRows.value, createExtraRow()]
}

/**
 * Desfaz o "Adicionar linha" antes do envio. Só linha sem `entryId` é removível
 * (o menu já filtra por isso): descartar aqui é jogar fora estado local, sem
 * chamada de API e sem rastro a auditar — a linha nunca existiu no backend.
 */
function handleMirrorRemoveRow(index: number) {
  const row = mirrorRows.value[index]
  if (!row || row.entryId !== null || isMirrorSaving.value) return
  mirrorRows.value = mirrorRows.value.filter((_, i) => i !== index)
}

/**
 * Decisão 2 — previsto que não consta na folha: ação explícita, a linha vira DIVERGENT e
 * segue visível na fila de exceções/pagamento. NUNCA desaparece em silêncio.
 */
async function handleMirrorMarkAbsent(index: number) {
  const row = mirrorRows.value[index]
  if (!row?.entryId || isMirrorSaving.value) return

  isMirrorSaving.value = true
  try {
    // O `containerId` na query não é decoração: é o que autoriza a rota no SpiceDB e o que
    // impede um entryId de outro registro de ser tocado (o backend devolve 404).
    const response = await Network.dsAttendance.markEntryAbsent(row.entryId, attendanceId.value)
    patchMirrorRow(index, {
      prefillOutcome: response.prefillOutcome ?? PrefillOutcome.ABSENT,
      validationStatus: response.validationStatus ?? ValidationStatus.DIVERGENT
    })
    await refreshHistory()
    toast.success('Linha marcada como não consta na folha — segue para a fila de divergências.')
  } catch (error) {
    notifyError(error, 'Não foi possível marcar a linha como ausente da folha.')
  } finally {
    isMirrorSaving.value = false
  }
}

/**
 * Desfaz a ausência: a linha volta ao estado de pós-espelho e fica conciliável
 * de novo. Antes deste caminho o `prefillOutcome ABSENT` era terminal e o
 * auditor não conseguia mais usar a linha, nem recomeçando a auditoria.
 */
async function handleMirrorUnmarkAbsent(index: number) {
  const row = mirrorRows.value[index]
  if (!row?.entryId || isMirrorSaving.value) return

  isMirrorSaving.value = true
  try {
    const response = await Network.dsAttendance.unmarkEntryAbsent(row.entryId, attendanceId.value)
    patchMirrorRow(index, {
      prefillOutcome: response.prefillOutcome ?? null,
      validationStatus: response.validationStatus ?? ValidationStatus.PENDING,
      conciliationType: null,
      doctorStationId: response.doctorStationId ?? row.doctorStationId,
      sourceType: SourceType.PREFILLED
    })
    await refreshHistory()
    toast.success('Linha restaurada para a folha.')
  } catch (error) {
    notifyError(error, 'Não foi possível restaurar a linha para a folha.')
  } finally {
    isMirrorSaving.value = false
  }
}

/**
 * Decisão 4 — substituir médico: `confirm-conciliation` ecoando o `entryId` da linha e o
 * `doctorStationId` do candidato escolhido (fecha a limitação do BUG-01).
 *
 * INVARIANTE DURO: só a entry da folha muda. A `DoctorStation` / escala oficial JAMAIS é
 * alterada por este fluxo.
 */
async function handleMirrorReplaceDoctor(payload: { index: number; doctorStationId: number }) {
  const row = mirrorRows.value[payload.index]
  if (!row?.entryId || isMirrorSaving.value) return

  const candidateRow = mirrorRows.value.find(
    (current) => current.doctorStationId === payload.doctorStationId
  )

  isMirrorSaving.value = true
  try {
    await Network.dsAttendance.confirmConciliation(attendanceId.value, {
      entries: [
        {
          entryId: row.entryId,
          doctorStationId: payload.doctorStationId,
          validationStatus: ValidationStatus.CONCILIATED,
          conciliationType: ConciliationType.MANUAL
        }
      ]
    })
    patchMirrorRow(payload.index, {
      doctorStationId: payload.doctorStationId,
      doctorName: candidateRow?.doctorName ?? row.doctorName,
      crm: candidateRow?.crm ?? row.crm,
      prefillOutcome: PrefillOutcome.EDITED,
      validationStatus: ValidationStatus.CONCILIATED
    })
    await refreshHistory()
    toast.success('Médico substituído nesta linha da folha. A escala oficial não foi alterada.')
  } catch (error) {
    notifyError(error, 'Não foi possível substituir o médico desta linha.')
  } finally {
    isMirrorSaving.value = false
  }
}

/**
 * BUG UI-8 (relatório 03/09) — "Desfazer conciliação automática" direto na linha do espelho:
 * o recurso já existia no fluxo clássico (`handleUndoAutomaticConciliation`, no modal de
 * conciliação) mas não tinha equivalente aqui, único caminho quando o prefill está
 * disponível. Mesmo endpoint/gate já auditado no backend (28-03,
 * `AUTOMATIC_CONCILIATION_REVERSED`), ecoando `entryId` + `containerId`. A linha volta a
 * "Pré-preenchido" — pronta para revisão manual do auditor.
 */
async function handleMirrorUndoConciliation(entryId: number) {
  if (isMirrorSaving.value) return

  isMirrorSaving.value = true
  try {
    await Network.dsAttendance.confirmConciliation(attendanceId.value, {
      entries: [
        {
          entryId,
          validationStatus: ValidationStatus.DIVERGENT,
          divergenceReason: 'Revertido manualmente pelo auditor'
        }
      ]
    })
    const index = mirrorRows.value.findIndex((row) => row.entryId === entryId)
    if (index !== -1) {
      patchMirrorRow(index, {
        validationStatus: ValidationStatus.DIVERGENT,
        conciliationType: null,
        prefillOutcome: null
      })
    }
    await refreshHistory()
    toast.success('Conciliação automática desfeita — revise a linha manualmente.')
  } catch (error) {
    notifyError(error, 'Não foi possível desfazer a conciliação automática desta linha.')
  } finally {
    isMirrorSaving.value = false
  }
}

/**
 * Decisões 1/5/7 — o OK global: um clique fecha todas as linhas intocadas e grava UMA
 * conferência da folha na trilha. O checkbox do modal é a única marcação obrigatória.
 */
async function confirmSheetConference() {
  if (isMirrorSaving.value) return

  isMirrorSaving.value = true
  try {
    await Network.dsAttendance.confirmSheetConference(attendanceId.value, {
      signaturesChecked: true,
      templateId: selectedSheetModel.value?.id
    })
    mirrorRows.value = mirrorRows.value.map((row) =>
      resolveRowState(row) === 'PREFILLED'
        ? { ...row, prefillOutcome: PrefillOutcome.CONFIRMED }
        : row
    )
    hasSheetConference.value = true
    isSheetConferenceModalOpen.value = false
    await refreshHistory()
    toast.success('Conferência da folha confirmada.')
  } catch (error) {
    notifyError(error, 'Não foi possível confirmar a conferência da folha.')
  } finally {
    isMirrorSaving.value = false
  }
}

function startValidation() {
  isValidating.value = true
  emit('startValidation')
  // O prefill é disparado pela SELEÇÃO do modelo; ao iniciar a validação o modelo já está
  // escolhido (o primeiro é aplicado no carregamento), então o espelho nasce aqui.
  if (isSheetV2 && selectedSheetModel.value) void runPrefill(selectedSheetModel.value.id)
}

function cancelValidation() {
  isValidating.value = false
  hasConciliationStarted.value = false
  hasConciliationBeenConfirmed.value = false
  // O espelho é estado de tela: as entries seguem no backend (o prefill é idempotente e as
  // devolve inteiras na próxima seleção de modelo), mas a grade local zera junto.
  mirrorRows.value = []
  prefillEmptyReason.value = null
  prefillExpectedDoctorStations.value = null
  prefillUnidentifiedCount.value = 0
  prefillUnidentifiedStations.value = []
  prefillError.value = null
  prefillFailureCount.value = 0
  userForcedClassic.value = false
  hasSheetConference.value = false
  isSheetConferenceModalOpen.value = false
}

function handleBack() {
  if (isConciliationDone.value) {
    isConciliationDone.value = false
    isValidating.value = true
    hasConciliationStarted.value = false
    hasConciliationBeenConfirmed.value = false
    isConfirmingConciliation.value = false
    validationStatus.value = null
    validationObservation.value = ''
    rejectionReason.value = null
    auditInProgressReason.value = null
  } else if (isValidating.value) {
    guardUnsavedExit(cancelValidation)
  } else {
    handleClose()
  }
}

/**
 * RF-07/RN-10 (#2115) — nenhum caminho de saída descarta a transcrição em silêncio: o
 * critério é `hasUnsavedSheetWork`: `hasRowsInUse` (RN-03) na grade de digitação e a edição
 * local ainda não enviada na grade do espelho. Três caminhos cobertos:
 * o botão "Cancelar" (`guardUnsavedExit`), sair da rota (`onBeforeRouteLeave`) e fechar
 * a aba/recarregar (`beforeunload`, aviso nativo do navegador). Só existe atrás de
 * `isSheetV2` — a flag desligada preserva a saída direta de hoje.
 */
const isUnsavedExitModalOpen = ref(false)
let pendingRouteLeaveNext: ((valid?: boolean) => void) | null = null
let pendingExitAction: (() => void) | null = null

function guardUnsavedExit(onConfirm: () => void) {
  if (isSheetV2 && isValidating.value && hasUnsavedSheetWork.value) {
    pendingExitAction = onConfirm
    isUnsavedExitModalOpen.value = true
    return
  }
  onConfirm()
}

function confirmUnsavedExit() {
  isUnsavedExitModalOpen.value = false
  if (pendingRouteLeaveNext) {
    pendingRouteLeaveNext(true)
    pendingRouteLeaveNext = null
    return
  }
  pendingExitAction?.()
  pendingExitAction = null
}

function cancelUnsavedExit() {
  isUnsavedExitModalOpen.value = false
  if (pendingRouteLeaveNext) {
    pendingRouteLeaveNext(false)
    pendingRouteLeaveNext = null
  }
  pendingExitAction = null
}

onBeforeRouteLeave((_to, _from, next) => {
  if (isSheetV2 && isValidating.value && hasUnsavedSheetWork.value) {
    pendingRouteLeaveNext = next
    isUnsavedExitModalOpen.value = true
    return
  }
  next()
})

function handleBeforeUnload(event: BeforeUnloadEvent) {
  if (isSheetV2 && isValidating.value && hasUnsavedSheetWork.value) {
    event.preventDefault()
    event.returnValue = ''
  }
}

const isDiscardEmptyRowsModalOpen = ref(false)
const conciliatedRowIndexes = ref<number[]>([])

/**
 * As linhas efetivamente enviadas à conciliação, na ordem do payload — o `rowIndex` que o
 * backend devolve indexa esta lista, não a tabela inteira.
 */
const conciliatedSheetRows = computed(() => {
  if (hasPrefillMirror.value) return mirrorConciliatedRows.value.map(toSheetShapedRow)
  return conciliatedRowIndexes.value.map((index) => sheetRows.value[index])
})

/** Linhas do espelho enviadas à conciliação, na ordem do payload (indexadas por `rowIndex`). */
const mirrorConciliatedRows = ref<MirrorRow[]>([])

/**
 * Projeta uma linha do espelho nas chaves das colunas do modelo de folha, para que o modal
 * de conciliação e a tabela de validação (`viewRows`/`viewColumns`) continuem lendo as
 * mesmas chaves de sempre — nenhum dos dois precisa saber que existe um espelho. O mapa é o
 * MESMO `KNOWN_COLUMN_MAP` que monta o payload, nunca uma heurística nova de label.
 */
function toSheetShapedRow(row: MirrorRow): Record<string, string | boolean> {
  const MIRROR_FIELD_VALUES: Record<string, string | boolean> = {
    rawDoctorName: row.doctorName,
    rawCrm: row.crm,
    checkinReal: row.checkin,
    checkoutReal: row.checkout,
    hasDoctorSignature: row.hasDoctorSignature,
    hasDoctorStamp: row.hasDoctorStamp
  }

  const projected: Record<string, string | boolean> = {
    // Aliases lidos pelo modal de conciliação para exibir a jornada da linha.
    jornada_inicio: row.checkin,
    jornada_fim: row.checkout
  }

  for (const column of sheetColumns.value) {
    const field = KNOWN_COLUMN_MAP[normalizeColumnKey(column.key)]
    if (field && field in MIRROR_FIELD_VALUES) {
      projected[column.key] = MIRROR_FIELD_VALUES[field]
    }
  }

  return projected
}

/**
 * RN-10 — este clique é o único ponto sem volta do fluxo: nada é persistido antes dele e o
 * descarte das linhas vazias acontece exatamente aqui, sem aparecer no payload. Dispensam a
 * confirmação a flag desligada e a reabertura da conciliação já confirmada, que não envia
 * nada de novo.
 */
function handleAdvanceClick() {
  // No espelho não existe "linha vazia a descartar": a grade nasce da escala e a linha extra
  // em branco simplesmente não entra no payload — a confirmação de descarte perderia sentido.
  if (!isSheetV2 || hasConciliationBeenConfirmed.value || hasPrefillMirror.value) {
    advanceToReconciliation()
    return
  }
  isDiscardEmptyRowsModalOpen.value = true
}

function confirmDiscardEmptyRows() {
  isDiscardEmptyRowsModalOpen.value = false
  advanceToReconciliation()
}

async function advanceToReconciliation() {
  if (!selectedSheetModel.value) return

  hasConciliationStarted.value = true

  if (hasConciliationBeenConfirmed.value) {
    isConciliationModalOpen.value = true
    return
  }

  isConciliating.value = true

  // ESP-02/29-04 — no espelho o payload sai da própria grade, com o `entryId` ecoado em toda
  // linha pré-existente: é o eco que faz o backend reclamar a entry por identidade, nunca
  // pela posição no array (limitação do BUG-01).
  if (hasPrefillMirror.value) {
    mirrorConciliatedRows.value = mirrorRows.value.filter(
      (row) => resolveRowState(row) !== PrefillOutcome.ABSENT && (row.doctorName || row.crm)
    )
    try {
      const response = await Network.dsAttendance.conciliate(attendanceId.value, {
        templateId: selectedSheetModel.value.id,
        rows: toConciliateRows(mirrorRows.value, details.value?.referenceDate ?? '')
      })
      conciliationRows.value = response.rows
      isConciliationModalOpen.value = true
    } catch (error) {
      notifyError(error, 'Não foi possível iniciar a conciliação da folha.')
    } finally {
      isConciliating.value = false
    }
    return
  }

  // RN-03/RF-02 — linhas vazias são descartadas aqui e não entram no payload. O backend
  // devolve `rowIndex` relativo a esta lista, então os índices de origem são guardados
  // para reencontrar a linha correspondente na tabela.
  conciliatedRowIndexes.value = rowsInUseIndexes.value
  try {
    const response = await Network.dsAttendance.conciliate(attendanceId.value, {
      templateId: selectedSheetModel.value.id,
      rows: conciliatedSheetRows.value.map((row) => {
        const topLevel: Record<string, unknown> = {}
        const extra: Record<string, unknown> = {}

        for (const [key, value] of Object.entries(row)) {
          const mapped = KNOWN_COLUMN_MAP[normalizeColumnKey(key)]
          if (mapped) {
            if (TIME_FIELDS.has(mapped)) {
              topLevel[mapped] = toISODateTime(String(value), details.value!.referenceDate)
            } else if (BOOLEAN_FIELDS.has(mapped)) {
              topLevel[mapped] = Boolean(value)
            } else {
              topLevel[mapped] = value
            }
          } else {
            extra[key] = value
          }
        }

        if (topLevel.checkinReal && topLevel.checkoutReal) {
          const ci = new Date(topLevel.checkinReal as string)
          const co = new Date(topLevel.checkoutReal as string)
          if (co < ci) {
            co.setDate(co.getDate() + 1)
            topLevel.checkoutReal = co.toISOString()
          }
        }

        return {
          ...topLevel,
          hasDoctorSignature: Boolean(topLevel.hasDoctorSignature ?? false),
          hasDoctorStamp: Boolean(topLevel.hasDoctorStamp ?? false),
          additionalFields: extra
        }
      })
    })
    conciliationRows.value = response.rows
    isConciliationModalOpen.value = true
  } catch (error) {
    notifyError(error, 'Não foi possível iniciar a conciliação da folha.')
  } finally {
    isConciliating.value = false
  }
}

const isConfirmingConciliation = ref(false)

async function handleConciliationConfirm(
  selections: Record<number, number>,
  divergenceReasons: Record<number, string> = {}
) {
  if (isConfirmingConciliation.value) return
  isConfirmingConciliation.value = true

  hasConciliationBeenConfirmed.value = true
  viewRows.value = conciliationRows.value.map((row) => {
    // QW-01/28-06 — linha pré-confirmada nunca passou pelo modal (não está em `selections`);
    // o casamento dela já veio pronto do backend em `row.doctorStationId`.
    const selectedId = isPreConfirmedConciliationRow(row)
      ? row.doctorStationId
      : selections[row.rowIndex]
    const candidate = row.candidates.find((c) => c.doctorStationId === selectedId)
    const conciliation = candidate
      ? { type: 'success', text: `#${candidate.stationId}` }
      : { type: 'warning', text: 'Sem correspondência' }
    return { ...conciliatedSheetRows.value[row.rowIndex], conciliation }
  })

  // QW-01/28-06 — linhas pré-confirmadas (não tocadas pelo "Desfazer") não são reenviadas: o
  // backend já as gravou como CONCILIATED+AUTOMATIC dentro de conciliate() (plano 28-02).
  // Reenviar seria um no-op tolerado pelo backend, mas sem motivo para gerar tráfego extra.
  const entries = pendingConciliationRows.value.map((row) => {
    const selectedDsId = selections[row.rowIndex]
    if (selectedDsId) {
      return {
        entryId: row.entryId,
        doctorStationId: selectedDsId,
        validationStatus: ValidationStatus.CONCILIATED,
        conciliationType:
          row.candidates.length === 1 ? ConciliationType.AUTOMATIC : ConciliationType.MANUAL
      }
    }
    return {
      entryId: row.entryId,
      validationStatus: ValidationStatus.DIVERGENT,
      divergenceReason: resolveDivergenceReason(divergenceReasons, row.rowIndex)
    }
  })

  try {
    await Network.dsAttendance.confirmConciliation(attendanceId.value, { entries })
    isConciliationDone.value = true
    isValidating.value = false
  } catch (error) {
    hasConciliationBeenConfirmed.value = false
    notifyError(error, 'Não foi possível salvar a conciliação da folha.')
  } finally {
    isConfirmingConciliation.value = false
  }
}

// Spec 2026-09-24 §8.1 — aprovar passa pela prévia da sobrescrita de perna.
const legOverwrite = useLegOverwriteApproval()
const {
  isOpen: isLegOverwriteOpen,
  conflicts: legOverwriteConflicts,
  effectiveValues: legOverwriteEffectiveValues,
  effectiveValueStatus: legOverwriteEffectiveValueStatus,
  isSubmitting: isLegOverwriteSubmitting,
  errorMessage: legOverwriteError,
  staleNotice: legOverwriteStale
} = legOverwrite

/**
 * O POST da decisão do auditor. Separado de `saveValidation` só para manter a complexidade.
 * Devolve `false` quando o auditor cancelou a confirmação da sobrescrita de perna: nada foi
 * gravado e a tela fica onde está.
 */
async function submitValidationDecision(id: string): Promise<boolean> {
  if (validationStatus.value === 'APROVADO') {
    const outcome = await legOverwrite.approve(id, {
      justification: validationObservation.value || undefined
    })
    if (outcome === 'CANCELLED') return false
    toast.success('Registro aprovado com sucesso.')
    return true
  }
  if (validationStatus.value === 'AUDITORIA_EM_PROGRESSO') {
    await Network.dsAttendance.startAudit(id, {
      reason: auditInProgressReason.value || undefined,
      observation: validationObservation.value || undefined
    })
    toast.success('Container mantido em auditoria.')
  }
  return true
}

/**
 * `openNext` liga o encadeamento do Eixo 4: aprovou, pede o próximo da MESMA fila e abre.
 * Só vale para "APROVADO" — manter em auditoria não avança a fila, e reprovar abre o modal.
 * Se o próximo sumiu entre a abertura da tela e a aprovação, cai no `handleClose()` de hoje:
 * o registro já está aprovado de qualquer forma, então falhar a navegação não é erro.
 */
/**
 * Ponto único dos três gatilhos (Salvar validação, Aprovar e abrir o próximo e Ctrl+Enter):
 * Aprovada com linha sem correspondência passa antes pela confirmação (web#2336).
 */
function saveValidation(options: { openNext?: boolean } = {}) {
  unmatchedApprovalGate.guard(validationStatus.value, unmatchedRowsCount.value, () =>
    persistValidation(options)
  )
}

async function persistValidation(options: { openNext?: boolean }) {
  const id = attendanceId.value

  if (validationStatus.value === 'REPROVADO') {
    isRejectModalOpen.value = true
    return
  }

  const chainToNext = options.openNext === true && validationStatus.value === 'APROVADO'

  try {
    isSaving.value = true
    if (chainToNext) isGoingToNext.value = true

    const done = await submitValidationDecision(id)
    if (!done) return

    if (chainToNext && (await goToNext(id, nextContainerId.value))) return

    handleClose()
  } catch (error) {
    notifyError(error, 'Não foi possível salvar a validação do registro.')
  } finally {
    isSaving.value = false
    isGoingToNext.value = false
  }
}

/**
 * `Ctrl+Enter` na tela de auditoria = a ação primária do rodapé. Com próximo na fila,
 * encadeia; sem próximo, é exatamente o "Salvar validação" de hoje. Ignorado quando o botão
 * estaria desabilitado, para o atalho nunca fazer algo que o clique não faria.
 *
 * Mesma guarda de foco do atalho `L`: `Ctrl+Enter` dentro do campo de comentário é quebra de
 * linha para quem digita, não "aprovar" — aprovar a folha por baixo do texto em edição seria
 * uma ação destrutiva disparada sem intenção.
 */
function handleApproveShortcut(event: KeyboardEvent) {
  if (event.key !== 'Enter') return
  if (!event.ctrlKey && !event.metaKey) return
  if (isTypingTarget(event.target)) return
  if (!isConciliationDone.value || isSaveValidationDisabled.value) return
  event.preventDefault()
  saveValidation({ openNext: hasNextContainer.value })
}

async function executeRejection(payload: {
  reason: string
  justification?: string
  requestNewSheet: boolean
}) {
  try {
    isSaving.value = true
    await Network.dsAttendance.rejectContainer(attendanceId.value, {
      reason: payload.reason,
      justification: payload.justification,
      requestNewSheet: payload.requestNewSheet
    })
    toast.success(
      payload.requestNewSheet ? 'Registro reprovado. Nova folha solicitada.' : 'Registro reprovado.'
    )
    isRejectModalOpen.value = false
    handleClose()
  } catch (error) {
    notifyError(error, 'Não foi possível reprovar o registro de presença.')
  } finally {
    isSaving.value = false
  }
}
// ---------------------------------------------------------------------------------------
// Cara-crachá V1 + lupa (spec 2026-09-11 §7 item 1) — visualizador em largura total no topo
// ---------------------------------------------------------------------------------------

/** Página que o visualizador mostra; controlada daqui para a grade poder pular a folha. */
const viewerPage = ref(1)
/**
 * `0` = ainda não se sabe quantas páginas a folha tem (o PDF carrega em segundo plano e a
 * evidência pode ser imagem). Clicar numa página antes disso não pode ser truncado para 1 —
 * `clampPage` trata o zero como "sem limite conhecido".
 */
const viewerTotalPages = ref(0)

/** Altura da folha: ~58% da viewport por padrão, arrastável, nunca abaixo de 320 px. */
const viewerHeightPx = ref(DEFAULT_VIEWER_HEIGHT_PX)

/** Linha realçada (`sel` do mockup V1) — sincroniza com a página da folha. */
const selectedMirrorIndex = ref<number | null>(null)

const isMagnifierOn = ref(false)
const isHistoryOpen = ref(false)
const isAutoApprovalCriteriaModalOpen = ref(false)

function resolveInitialViewerHeight(): number {
  const viewport = typeof window === 'undefined' ? 0 : window.innerHeight
  if (!viewport) return DEFAULT_VIEWER_HEIGHT_PX
  return Math.max(VIEWER_MIN_HEIGHT_PX, Math.round(viewport * 0.58))
}

let resizeStartY = 0
let resizeStartHeight = 0

function onViewerResizeMove(event: MouseEvent) {
  const next = resizeStartHeight + (event.clientY - resizeStartY)
  viewerHeightPx.value = Math.max(VIEWER_MIN_HEIGHT_PX, Math.round(next))
}

function stopViewerResize() {
  window.removeEventListener('mousemove', onViewerResizeMove)
  window.removeEventListener('mouseup', stopViewerResize)
}

function startViewerResize(event: MouseEvent) {
  resizeStartY = event.clientY
  resizeStartHeight = viewerHeightPx.value
  window.addEventListener('mousemove', onViewerResizeMove)
  window.addEventListener('mouseup', stopViewerResize)
}

/**
 * Rotação bloqueia a lupa: a lente mostraria outra região da folha. Mesma regra que o
 * visualizador usa para esconder a lente — aqui ela desabilita o botão e explica o motivo.
 */
const isMagnifierBlockedByRotation = computed(() => magnifierBlockedByRotation(rotation.value))

/** Lupa: lembrada por usuário no navegador (try/catch dentro do helper). */
function toggleMagnifier(next?: boolean) {
  if (isMagnifierBlockedByRotation.value) return
  isMagnifierOn.value = next ?? !isMagnifierOn.value
  writeMagnifierPreference(isMagnifierOn.value)
}

/** Atalho `L` — ignorado enquanto o foco está num campo, senão come a letra digitada. */
function handleMagnifierShortcut(event: KeyboardEvent) {
  if (event.key !== 'l' && event.key !== 'L') return
  if (event.metaKey || event.ctrlKey || event.altKey) return
  if (isTypingTarget(event.target)) return
  event.preventDefault()
  toggleMagnifier()
}

function goToViewerPage(page: number) {
  viewerPage.value = clampPage(page, viewerTotalPages.value)
}

/** Clique no número da coluna "Página da Folha": a folha pula e a linha fica realçada. */
function handleMirrorJumpToPage(page: number) {
  goToViewerPage(page)
}

/** Seleção de linha: página conhecida troca a folha; sem página, só realça. */
function handleMirrorSelectRow(index: number) {
  selectedMirrorIndex.value = index
  const page = resolveRowPage(mirrorRows.value[index] ?? null)
  if (page !== null) goToViewerPage(page)
}

/**
 * "Marcar página atual": grava a página no estado da linha. A persistência não precisa de
 * endpoint novo — `pageNumber` já viaja nas `rows` do `/conciliate` que o avanço chama.
 */
function handleMirrorMarkCurrentPage(index: number) {
  if (!isValidPage(viewerPage.value)) return
  patchMirrorRow(index, { pageNumber: viewerPage.value })
  selectedMirrorIndex.value = index
}

// ---------------------------------------------------------------------------------------
// Fase 2 (§6) — "Aprovado automaticamente" e motivo de revisão manual
// ---------------------------------------------------------------------------------------

const approvalMode = computed<DSAttendanceApprovalMode | null>(
  () => (details.value?.approvalMode as DSAttendanceApprovalMode | undefined) ?? null
)

const isAutoApproved = computed(() => isApproved.value && approvalMode.value === 'AUTOMATIC')

/** Chip âmbar do motivo — só quando o backend gravou um; sempre visível, aprovado ou não. */
const manualReviewChipLabel = computed(() =>
  manualReviewReasonLabel(details.value?.manualReviewReason)
)

/** N do banner: as linhas do espelho e, na falta delas, os plantões previstos (§6.3). */
const autoApprovedLineCount = computed(
  () => details.value?.prefillTotalLines ?? details.value?.expectedDoctorStations ?? null
)

/** Vetor de critérios do audit `CONTAINER_AUTO_APPROVED`; vazio cai no texto estático. */
const autoApprovalCriteria = ref<DSAttendanceAutoApprovalCriterion[]>([])

/** Faixa compacta: os mesmos pares do painel lateral antigo, em uma linha. */
const headerFacts = computed(() => {
  const facts = [
    { label: 'Data', value: date.value },
    { label: 'Unidade', value: unit.value },
    { label: 'Escala(s)', value: schedules.value },
    { label: 'Turno(s)', value: shifts.value },
    { label: 'Estado', value: imageState.value }
  ]
  if (isValidating.value) return facts
  return [
    ...facts,
    { label: 'Envio', value: sentBy.value },
    { label: 'Validação', value: validatedBy.value }
  ]
})
/**
 * A gaveta de histórico/comentários nasce fora do caminho quando se abre a tela já validando e
 * aberta fora disso — é o estado INICIAL do layout V1, não uma regra permanente: depois disso
 * quem manda é o toggle do auditor, e reaplicar a regra a cada mudança de `isValidating`
 * fechava a gaveta que ele tinha acabado de abrir.
 */
let hasAppliedHistoryDefault = false
watch(
  () => isValidating.value,
  (validating) => {
    if (hasAppliedHistoryDefault) return
    hasAppliedHistoryDefault = true
    isHistoryOpen.value = !validating
  },
  { immediate: true }
)

/**
 * Integridade de auditoria — "Aprovar e abrir o próximo" trocando o registro sem trocar a tela.
 *
 * As rotas `DsAttendancePendingAudit` e `DsAttendanceApproved` apontam para ESTE componente, e
 * `goToNext` navega com `router.push` para a mesma rota: o Vue reaproveita a instância e
 * NENHUM `onMounted` roda de novo. Só `attendanceId` (computado sobre `route.params`) mudava —
 * os botões passavam a agir sobre o registro novo enquanto a tela continuava mostrando o
 * anterior, ou seja, o auditor podia aprovar um registro sem nunca ter visto o anexo dele.
 *
 * Este watch é o `onMounted` que falta: zera o que é escopo do registro e refaz a carga.
 */
function resetContainerScopedState(): void {
  // O detalhe antigo tem de sair ANTES da nova carga: é ele que o filho de Atividade recebe
  // por prop e é dele que saem os fatos do cabeçalho. Exibir "Não informado" por um instante
  // é correto por omissão; exibir o registro anterior como se fosse o novo, não.
  details.value = null

  // Carga principal e seus estados de erro (BUG-PP-02) — o retry é do registro atual.
  hasLoadError.value = false
  loadErrorMessage.value = null
  isRetrying.value = false

  // Secundários: evidência (blob revogado como no unmount) e trilha de auditoria.
  if (fileUrl.value?.startsWith('blob:')) URL.revokeObjectURL(fileUrl.value)
  fileUrl.value = undefined
  isLoadingEvidence.value = true
  historyEvents.value = []
  isLoadingHistory.value = true
  autoApprovalCriteria.value = []

  // O "próximo da fila" é do registro anterior: reconsultado logo abaixo, depois da carga.
  nextContainerId.value = null
  isGoingToNext.value = false

  // Folha, espelho e conciliação — carregar o registro novo com as linhas digitadas no
  // anterior seria escrever a folha errada.
  selectedSheetModel.value = null
  pendingSheetModel.value = null
  sheetColumns.value = []
  sheetRows.value = []
  mirrorRows.value = []
  mirrorConciliatedRows.value = []
  conciliationRows.value = []
  conciliatedRowIndexes.value = []
  viewRows.value = []
  selectedMirrorIndex.value = null
  hasSheetConference.value = false
  prefillEmptyReason.value = null
  prefillExpectedDoctorStations.value = null
  prefillUnidentifiedCount.value = 0
  prefillUnidentifiedStations.value = []
  prefillError.value = null
  prefillFailureCount.value = 0
  userForcedClassic.value = false
  isPrefilling.value = false
  isMirrorSaving.value = false

  // Decisão do auditor: nada do registro anterior pode ficar pré-selecionado no novo.
  isValidating.value = false
  isConciliating.value = false
  isConfirmingConciliation.value = false
  hasConciliationStarted.value = false
  hasConciliationBeenConfirmed.value = false
  isConciliationDone.value = false
  validationStatus.value = null
  validationObservation.value = ''
  rejectionReason.value = null
  auditInProgressReason.value = null
  undoingAutomaticConciliationEntryId.value = null
  isSaving.value = false
  isReverting.value = false
  isProcessingJustification.value = false

  // Modais abertos sobre o registro anterior agiriam sobre o novo ao confirmar.
  isConciliationModalOpen.value = false
  isRejectModalOpen.value = false
  isRevertModalOpen.value = false
  isSubmitJustificationModalOpen.value = false
  isRejectJustificationModalOpen.value = false
  isSwitchTemplateModalOpen.value = false
  isUnsavedExitModalOpen.value = false
  isDiscardEmptyRowsModalOpen.value = false
  isSheetConferenceModalOpen.value = false
  isAutoApprovalCriteriaModalOpen.value = false

  // Visualizador do anexo: página/rotação/zoom são do documento anterior.
  viewerPage.value = 1
  viewerTotalPages.value = 0
  rotation.value = 0
  zoom.value = 1
}

watch(attendanceId, async (newId, oldId) => {
  if (newId === oldId) return

  resetContainerScopedState()

  // Mesma promessa que os hooks de montagem esperam: quem decide se o resto vale é `kind`,
  // que só existe depois do `getById`.
  initialLoad = loadAll()
  await initialLoad

  /**
   * Trocar de FOLHA para ATIVIDADE (ou o contrário) troca de tela: os atalhos daqui não podem
   * sobreviver a uma tela que não é mais esta. Reinscrever o mesmo listener é no-op no DOM.
   */
  if (isActivityKind.value) {
    window.removeEventListener('keydown', handleApproveShortcut)
    window.removeEventListener('keydown', handleMagnifierShortcut)
    return
  }
  window.addEventListener('keydown', handleApproveShortcut)
  window.addEventListener('keydown', handleMagnifierShortcut)

  nextContainerId.value = await fetchNextId(attendanceId.value)
  isMagnifierOn.value = readMagnifierPreference()
  viewerHeightPx.value = resolveInitialViewerHeight()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isActivityKind.value)
      ? (_openBlock(), _createBlock(DsAttendanceActivityAudit, {
          key: attendanceId.value,
          "data-testid": "ds-attendance-activity-audit-host",
          "container-id": attendanceId.value,
          "container-detail": details.value
        }, null, 8, ["container-id", "container-detail"]))
      : (hasLoadError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiAlertCircleOutline)), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _hoisted_2,
              (loadErrorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(loadErrorMessage.value), 1))
                : _createCommentVNode("", true),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(FilledButton, {
                text: "Tentar novamente",
                "data-testid": "ds-attendance-detail-retry-button",
                class: "w-full sm:w-auto bg-primary30",
                width: "180px",
                height: "40px",
                disabled: isRetrying.value,
                onClick: retryLoad
              }, null, 8, ["disabled"]),
              _createVNode(OutlineButton, {
                text: "Voltar para Aprovações",
                "data-testid": "ds-attendance-detail-back-button",
                class: "w-full sm:w-auto",
                width: "200px",
                height: "40px",
                onClick: goToApprovals
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, "#" + _toDisplayString(attendanceId.value), 1),
                _createElementVNode("span", {
                  class: "text-textPrimary font-bold text-base truncate max-w-[260px]",
                  title: fileName.value
                }, _toDisplayString(fileName.value), 9, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(StatusBadge, { status: currentStatus.value }, null, 8, ["status"]),
                  (hasScheduleExpected.value === false)
                    ? (_openBlock(), _createBlock(LabelBadge, {
                        key: 0,
                        "data-testid": "ds-attendance-audit-no-schedule-expected",
                        label: _unref(NO_SCHEDULE_EXPECTED_LABEL),
                        color: "gray",
                        size: "small",
                        title: noScheduleExpectedTooltip.value
                      }, null, 8, ["label", "title"]))
                    : _createCommentVNode("", true),
                  (isAutoApproved.value)
                    ? (_openBlock(), _createBlock(LabelBadge, {
                        key: 1,
                        "data-testid": "ds-attendance-audit-approval-mode-chip",
                        label: _unref(APPROVAL_MODE_LABELS).AUTOMATIC,
                        color: "green",
                        size: "small"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (manualReviewChipLabel.value)
                    ? (_openBlock(), _createBlock(LabelBadge, {
                        key: 2,
                        "data-testid": "ds-attendance-audit-manual-review-chip",
                        label: manualReviewChipLabel.value,
                        color: "orange",
                        size: "small",
                        title: "Motivo pelo qual este registro não foi aprovado automaticamente."
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("dl", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerFacts.value, (fact) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: fact.label,
                      class: "flex items-baseline gap-1"
                    }, [
                      _createElementVNode("dt", _hoisted_13, _toDisplayString(fact.label) + ":", 1),
                      _createElementVNode("dd", {
                        class: "truncate max-w-[200px]",
                        title: fact.value
                      }, _toDisplayString(fact.value), 9, _hoisted_14)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (newSheetAction.value === 'SUBMIT')
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 0,
                        text: "Enviar nova folha",
                        class: "sm:w-auto",
                        width: "170px",
                        height: "32px",
                        "data-testid": "ds-attendance-new-sheet-button",
                        disabled: isSubmittingNewSheet.value,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (isNewSheetModalOpen.value = true))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  ((isApproved.value || isRejected.value) && _unref(canRevertValidation))
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 1,
                        text: "Reverter validação",
                        class: "sm:w-auto bg-negative",
                        width: "180px",
                        height: "32px",
                        "data-testid": "ds-attendance-revert-button",
                        disabled: isReverting.value,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (isRevertModalOpen.value = true))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (newSheetAction.value === 'GO_TO_REPLACEMENT')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("p", { class: "text-sm leading-[18px] text-textPrimary" }, [
                      _createTextVNode(" Na reprovação foi solicitado o envio de uma nova folha. Já existe um registro substituto para esta data. "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-[#0043CE] underline font-medium",
                        "data-testid": "ds-attendance-replacement-link",
                        onClick: openReplacement
                      }, " Abrir registro substituto ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                (isLoadingEvidence.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "relative border border-lightGray30 rounded-lg overflow-hidden bg-lightGray30 flex items-center justify-center w-full",
                      style: _normalizeStyle({ height: `${viewerHeightPx.value}px` })
                    }, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary"
                      })
                    ], 4))
                  : (_openBlock(), _createBlock(StepPreview, {
                      key: 1,
                      mode: "preview",
                      file: null,
                      "file-url": fileUrl.value,
                      "file-type": fileType.value,
                      rotation: rotation.value,
                      zoom: zoom.value,
                      page: viewerPage.value,
                      magnifier: isMagnifierOn.value,
                      "magnifier-toggle": true,
                      "height-px": viewerHeightPx.value,
                      "show-display-name": false,
                      "onUpdate:rotation": _cache[2] || (_cache[2] = ($event: any) => (rotation.value = $event)),
                      "onUpdate:zoom": _cache[3] || (_cache[3] = ($event: any) => (zoom.value = $event)),
                      "onUpdate:page": _cache[4] || (_cache[4] = ($event: any) => (viewerPage.value = $event)),
                      "onUpdate:totalPages": _cache[5] || (_cache[5] = ($event: any) => (viewerTotalPages.value = $event)),
                      "onUpdate:magnifier": _cache[6] || (_cache[6] = ($event: any) => (toggleMagnifier($event)))
                    }, null, 8, ["file-url", "file-type", "rotation", "zoom", "page", "magnifier", "height-px"])),
                _createElementVNode("div", {
                  role: "separator",
                  "aria-orientation": "horizontal",
                  "aria-label": "Redimensionar a altura da folha",
                  "data-testid": "ds-attendance-viewer-resize-handle",
                  class: "mx-auto mt-1 h-2 w-24 cursor-row-resize rounded-full bg-lightGray30 hover:bg-primary10",
                  onMousedown: startViewerResize
                }, null, 32)
              ]),
              _createVNode(DsAttendancePreviousSheets, {
                "container-id": attendanceId.value,
                sheets: details.value?.previousSheets
              }, null, 8, ["container-id", "sheets"]),
              _createElementVNode("div", _hoisted_18, [
                (details.value?.stationChangedAfterAudit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
                  : _createCommentVNode("", true),
                _createVNode(DsAttendanceQualityWarnings, {
                  warnings: details.value?.qualityWarnings
                }, null, 8, ["warnings"]),
                _createVNode(DsAttendanceAutoApprovedPanel, {
                  "approval-mode": approvalMode.value,
                  "is-approved": isApproved.value,
                  "line-count": autoApprovedLineCount.value,
                  "can-reopen": _unref(canRevertValidation),
                  reopening: isReverting.value,
                  onShowCriteria: _cache[7] || (_cache[7] = ($event: any) => (isAutoApprovalCriteriaModalOpen.value = true)),
                  onReopen: _cache[8] || (_cache[8] = ($event: any) => (isRevertModalOpen.value = true))
                }, null, 8, ["approval-mode", "is-approved", "line-count", "can-reopen", "reopening"]),
                (isRejected.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", null, [
                        _hoisted_23,
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(REJECTION_REASON_LABELS)[details.value?.rejectionReason as RejectionReason] ??
                details.value?.rejectionReason ??
                'Não informada'), 1)
                      ]),
                      _hoisted_25
                    ], 64))
                  : _createCommentVNode("", true),
                (isValidating.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      (hasPrefillMirror.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("span", null, _toDisplayString(prefillNote.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!hasPrefillMirror.value && !hasPrefillError.value)
                        ? (_openBlock(), _createBlock(DsAttendancePrefillEmptyState, {
                            key: 1,
                            "empty-reason": prefillEmptyReason.value,
                            "schedule-name": schedules.value,
                            date: date.value,
                            shifts: shifts.value,
                            "reference-date": referenceDate.value,
                            "schedule-id": details.value?.schedule?.id ?? null
                          }, null, 8, ["empty-reason", "schedule-name", "date", "shifts", "reference-date", "schedule-id"]))
                        : _createCommentVNode("", true),
                      (hasPrefillError.value && !hasPrefillMirror.value)
                        ? (_openBlock(), _createBlock(DsAttendancePrefillErrorState, {
                            key: 2,
                            message: prefillError.value?.message ?? null,
                            "can-retry": prefillError.value?.canRetry ?? true,
                            "show-classic-escape": prefillFailureCount.value >= 2 && !userForcedClassic.value,
                            onRetry: retryPrefill,
                            onUseClassic: _cache[9] || (_cache[9] = ($event: any) => (userForcedClassic.value = true))
                          }, null, 8, ["message", "can-retry", "show-classic-escape"]))
                        : _createCommentVNode("", true),
                      (hasPrefillMirror.value && prefillUnidentifiedCount.value > 0)
                        ? (_openBlock(), _createBlock(UnidentifiedCoverageMirrorNotice, {
                            key: 3,
                            count: prefillUnidentifiedCount.value,
                            stations: prefillUnidentifiedStations.value
                          }, null, 8, ["count", "stations"]))
                        : _createCommentVNode("", true),
                      (hasPrefillMirror.value)
                        ? (_openBlock(), _createBlock(DsAttendanceSheetMirror, {
                            key: 4,
                            rows: mirrorRows.value,
                            disabled: isMirrorBusy.value,
                            "can-add-row": canAddMirrorRow.value,
                            "container-id": attendanceId.value,
                            "show-signature-stamp": !isExternalApp.value,
                            "current-page": viewerPage.value,
                            "selected-index": selectedMirrorIndex.value,
                            "eligibility-by-doctor-station": eligibilityByDoctorStation.value,
                            onJumpToPage: handleMirrorJumpToPage,
                            onMarkCurrentPage: handleMirrorMarkCurrentPage,
                            onSelectRow: handleMirrorSelectRow,
                            onUpdateCell: handleMirrorCell,
                            onSelectDoctor: handleMirrorSelectDoctor,
                            onAddRow: handleMirrorAddRow,
                            onRemoveRow: handleMirrorRemoveRow,
                            onMarkAbsent: handleMirrorMarkAbsent,
                            onUnmarkAbsent: handleMirrorUnmarkAbsent,
                            onReplaceDoctor: handleMirrorReplaceDoctor,
                            onUndoConciliation: handleMirrorUndoConciliation
                          }, null, 8, ["rows", "disabled", "can-add-row", "container-id", "show-signature-stamp", "current-page", "selected-index", "eligibility-by-doctor-station"]))
                        : (showClassicSheetGrid.value)
                          ? (_openBlock(), _createBlock(AttendanceSheetCard, {
                              key: 5,
                              ref_key: "sheetCardRef",
                              ref: sheetCardRef,
                              columns: sheetColumns.value,
                              rows: sheetRows.value,
                              "row-errors": sheetRowErrors.value,
                              "journey-rows": journeyRowIndexes.value,
                              "new-row-defaults": selectedSheetModel.value?.defaultRow ?? {},
                              "column-editors": sheetColumnEditors.value,
                              "get-column-menu-item": _unref(isSheetV2) ? getColumnMenuItem : undefined,
                              "max-rows": _unref(MAX_SHEET_ROWS),
                              "min-rows": _unref(MIN_SHEET_ROWS),
                              "row-limit-reason": _unref(rowLimitReason)(),
                              "min-row-limit-reason": _unref(minRowLimitReason)(),
                              mode: "edit",
                              engine: _unref(isSheetV2) ? 'spreadsheet' : 'native',
                              "onUpdate:rows": _cache[10] || (_cache[10] = ($event: any) => (sheetRows.value = $event))
                            }, null, 8, ["columns", "rows", "row-errors", "journey-rows", "new-row-defaults", "column-editors", "get-column-menu-item", "max-rows", "min-rows", "row-limit-reason", "min-row-limit-reason", "engine"]))
                          : _createCommentVNode("", true),
                      _createVNode(DsAttendanceSheetActionBar, {
                        "show-row-controls": _unref(isSheetV2) && !hasPrefillMirror.value,
                        reason: advanceBlockReason.value,
                        "can-undo": sheetCardRef.value?.canUndo ?? false,
                        "can-add-row": canAddRow.value,
                        "add-row-reason": addRowReason.value,
                        "can-delete-row": sheetCardRef.value?.canDeleteRow ?? false,
                        "delete-row-reason": deleteRowReason.value,
                        "sheet-models": sheetModels.value,
                        "selected-sheet-model": selectedSheetModel.value,
                        onUndo: _cache[11] || (_cache[11] = ($event: any) => (sheetCardRef.value?.undo())),
                        onAddRow: _cache[12] || (_cache[12] = ($event: any) => (sheetCardRef.value?.addRow())),
                        onDeleteRow: _cache[13] || (_cache[13] = ($event: any) => (sheetCardRef.value?.deleteRow())),
                        onSelectSheetModel: _cache[14] || (_cache[14] = (model) => handleSheetModelSelection(model as SheetModel))
                      }, null, 8, ["show-row-controls", "reason", "can-undo", "can-add-row", "add-row-reason", "can-delete-row", "delete-row-reason", "sheet-models", "selected-sheet-model"])
                    ]))
                  : (isConciliationDone.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(AttendanceSheetCard, {
                          columns: viewColumns.value,
                          rows: viewRows.value,
                          mode: "view"
                        }, null, 8, ["columns", "rows"]),
                        _createElementVNode("div", null, [
                          _hoisted_30,
                          _createVNode(_component_v_radio_group, {
                            modelValue: validationStatus.value,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((validationStatus).value = $event)),
                            "hide-details": "",
                            inline: "",
                            class: "mb-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Reprovada",
                                value: "REPROVADO",
                                color: "primary"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Auditoria em Progresso",
                                value: "AUDITORIA_EM_PROGRESSO",
                                color: "primary"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Aprovada",
                                value: "APROVADO",
                                color: "primary"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (unmatchedRowsCount.value > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_unref(unmatchedRowsMessage)(unmatchedRowsCount.value)) + " Ao aprovar, será pedida uma confirmação. ", 1))
                            : _createCommentVNode("", true),
                          (validationStatus.value === 'AUDITORIA_EM_PROGRESSO')
                            ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                key: 1,
                                modelValue: auditInProgressReason.value,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((auditInProgressReason).value = $event)),
                                items: _unref(AUDIT_IN_PROGRESS_REASON_OPTIONS),
                                "item-title": "title",
                                "item-value": "value",
                                label: "Justificativa",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "",
                                class: "mb-3",
                                "data-testid": "audit-in-progress-reason-select"
                              }, null, 8, ["modelValue", "items"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_textarea, {
                            modelValue: validationObservation.value,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((validationObservation).value = $event)),
                            label: "Observação",
                            variant: "outlined",
                            density: "compact",
                            rows: "3",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                (details.value?.hasPendingJustification && !isValidating.value && !isConciliationDone.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _hoisted_34,
                      (_unref(canAuditAttendance))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createVNode(OutlineButton, {
                              text: "Rejeitar",
                              width: "120px",
                              height: "36px",
                              disabled: isProcessingJustification.value,
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (isRejectJustificationModalOpen.value = true))
                            }, null, 8, ["disabled"]),
                            _createVNode(FilledButton, {
                              text: "Aceitar justificativa",
                              class: "bg-positive",
                              width: "180px",
                              height: "36px",
                              disabled: isProcessingJustification.value,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (handleAcceptJustification()))
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
            _unref(canEmit) &&
            isRejected.value &&
            !details.value?.hasPendingJustification &&
            !isValidating.value &&
            !isConciliationDone.value
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(OutlineButton, {
                        text: "Enviar justificativa",
                        width: "180px",
                        height: "36px",
                        disabled: isProcessingJustification.value,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (isSubmitJustificationModalOpen.value = true))
                      }, null, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (isValidating.value && hasPrefillMirror.value && advanceBlockReason.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(advanceBlockReason.value), 1))
                  : _createCommentVNode("", true),
                (!isApproved.value && !isRejected.value && !_unref(canAuditAttendance))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_unref(NO_AUDIT_PERMISSION_MESSAGE)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(OutlineButton, {
                    text: isConciliationDone.value ? 'Voltar' : isValidating.value ? 'Cancelar' : 'Fechar',
                    "data-testid": "attendance-back-button",
                    class: "w-full sm:w-auto",
                    width: "96px",
                    height: "40px",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (handleBack()))
                  }, null, 8, ["text"]),
                  (isApproved.value && fileUrl.value)
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 0,
                        text: "Ver folha digital",
                        "data-testid": "view-digital-sheet-button",
                        class: "w-full sm:w-auto bg-primary30",
                        width: "160px",
                        height: "40px",
                        onClick: openSheet
                      }))
                    : _createCommentVNode("", true),
                  (isConciliationDone.value)
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 1,
                        text: "Salvar validação",
                        "data-testid": "attendance-save-validation-button",
                        class: "w-full sm:w-auto bg-primary30",
                        width: "180px",
                        height: "40px",
                        disabled: isSaveValidationDisabled.value,
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (saveValidation()))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (isConciliationDone.value && hasNextContainer.value && validationStatus.value === 'APROVADO')
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 2,
                        text: "Aprovar e abrir o próximo",
                        "data-testid": "attendance-approve-and-next-button",
                        class: "w-full sm:w-auto bg-primary30",
                        width: "240px",
                        height: "40px",
                        disabled: isSaveValidationDisabled.value,
                        loading: isGoingToNext.value && !_unref(isLegOverwriteOpen),
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (saveValidation({ openNext: true })))
                      }, null, 8, ["disabled", "loading"]))
                    : _createCommentVNode("", true),
                  (
              !isApproved.value &&
              !isRejected.value &&
              !isConciliationDone.value &&
              !isValidating.value &&
              canReject.value &&
              _unref(canAuditAttendance)
            )
                    ? (_openBlock(), _createBlock(OutlineButton, {
                        key: 3,
                        text: "Reprovar",
                        "data-testid": "reject-direct-button",
                        class: "w-full sm:w-auto !text-red-600 !border-red-600 hover:!bg-[#FCE9EA]",
                        width: "120px",
                        height: "40px",
                        disabled: isSaving.value,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (isRejectModalOpen.value = true))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (!isApproved.value && !isRejected.value && !isConciliationDone.value && _unref(canAuditAttendance))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 4,
                        location: "top",
                        text: advanceTooltip.value ?? '',
                        disabled: !_unref(isSheetV2) || !advanceTooltip.value
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("span", _mergeProps(tooltipProps, { class: "w-full sm:w-auto" }), [
                            _createVNode(FilledButton, {
                              text: advanceButtonLabel.value,
                              "data-testid": "advance-to-conciliation-button",
                              class: "w-full sm:w-auto bg-primary30",
                              width: isValidating.value ? '230px' : '160px',
                              height: "40px",
                              disabled: 
                    (isValidating.value && !isSheetComplete.value) || isConciliating.value || hasConciliationStarted.value
                  ,
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (isValidating.value ? handleAdvanceClick() : startValidation()))
                            }, null, 8, ["text", "width", "disabled"])
                          ], 16)
                        ]),
                        _: 1
                      }, 8, ["text", "disabled"]))
                    : _createCommentVNode("", true),
                  (isValidating.value && hasPrefillMirror.value && !hasSheetConference.value)
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 5,
                        text: `✔ Confere com a escala (${pendingConferenceCount.value})`,
                        "data-testid": "sheet-conference-button",
                        class: "w-full sm:w-auto bg-primary30",
                        width: "260px",
                        height: "40px",
                        disabled: isMirrorBusy.value,
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (isSheetConferenceModalOpen.value = true))
                      }, null, 8, ["text", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "flex w-full items-center justify-between px-3 py-2 text-left text-sm font-bold text-textPrimary hover:bg-lightGray30/40",
                    "aria-expanded": isHistoryOpen.value,
                    "aria-controls": "ds-attendance-audit-drawer-content",
                    "data-testid": "ds-attendance-audit-drawer-toggle",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (isHistoryOpen.value = !isHistoryOpen.value))
                  }, [
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, _toDisplayString(isHistoryOpen.value ? '▴' : '▾'), 1)
                  ], 8, _hoisted_41),
                  (isHistoryOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (isLoadingHistory.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(DsAttendanceHistoryCardSkeleton, { class: "!w-full" }),
                              _createVNode(CommentsFormSkeleton)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(DsAttendanceHistoryCard, {
                                title: "Histórico",
                                events: historyEvents.value,
                                class: "!w-full"
                              }, null, 8, ["events"]),
                              _createVNode(CommentsForm, {
                                "attendance-id": attendanceId.value,
                                "can-comment": _unref(canEmit)
                              }, null, 8, ["attendance-id", "can-comment"])
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])),
    _createVNode(DsAttendanceConciliationModal, {
      modelValue: isConciliationModalOpen.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((isConciliationModalOpen).value = $event)),
      rows: pendingConciliationRows.value,
      "pre-confirmed-rows": preConfirmedConciliationRows.value,
      "undoing-entry-id": undoingAutomaticConciliationEntryId.value,
      "sheet-rows": conciliatedSheetRows.value,
      confirmed: hasConciliationBeenConfirmed.value,
      "hide-signature-columns": isExternalApp.value,
      onConfirm: handleConciliationConfirm,
      onUndo: handleUndoAutomaticConciliation
    }, null, 8, ["modelValue", "rows", "pre-confirmed-rows", "undoing-entry-id", "sheet-rows", "confirmed", "hide-signature-columns"]),
    _createVNode(DsAttendanceSheetConferenceModal, {
      modelValue: isSheetConferenceModalOpen.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((isSheetConferenceModalOpen).value = $event)),
      saving: isMirrorSaving.value,
      tally: mirrorTally.value,
      subtitle: sheetConferenceSubtitle.value,
      onConfirm: confirmSheetConference
    }, null, 8, ["modelValue", "saving", "tally", "subtitle"]),
    _createVNode(DsAttendanceDiscardEmptyRowsModal, {
      modelValue: isDiscardEmptyRowsModalOpen.value,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((isDiscardEmptyRowsModalOpen).value = $event)),
      saving: isConciliating.value,
      "empty-row-count": emptyRowCount.value,
      onConfirm: confirmDiscardEmptyRows
    }, null, 8, ["modelValue", "saving", "empty-row-count"]),
    _createVNode(DsAttendanceUnmatchedApprovalModal, {
      "model-value": _unref(isUnmatchedApprovalOpen),
      saving: isSaving.value,
      "unmatched-count": unmatchedRowsCount.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = (open) => !open && _unref(unmatchedApprovalGate).cancel()),
      onConfirm: _cache[32] || (_cache[32] = ($event: any) => (_unref(unmatchedApprovalGate).confirm()))
    }, null, 8, ["model-value", "saving", "unmatched-count"]),
    _createVNode(DsAttendanceSwitchTemplateModal, {
      "model-value": isSwitchTemplateModalOpen.value,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = (open) => !open && cancelSwitchSheetModel()),
      onConfirm: confirmSwitchSheetModel
    }, null, 8, ["model-value"]),
    _createVNode(DsAttendanceUnsavedExitModal, {
      "model-value": isUnsavedExitModalOpen.value,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = (open) => !open && cancelUnsavedExit()),
      onConfirm: confirmUnsavedExit
    }, null, 8, ["model-value"]),
    _createVNode(DsAttendanceRejectModal, {
      modelValue: isRejectModalOpen.value,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((isRejectModalOpen).value = $event)),
      saving: isSaving.value,
      "rejection-reason-options": rejectionReasonOptions.value,
      "initial-reason": rejectionReason.value,
      onConfirm: executeRejection
    }, null, 8, ["modelValue", "saving", "rejection-reason-options", "initial-reason"]),
    _createVNode(DsAttendanceNewSheetModal, {
      modelValue: isNewSheetModalOpen.value,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((isNewSheetModalOpen).value = $event)),
      saving: isSubmittingNewSheet.value,
      onConfirm: executeNewSheet
    }, null, 8, ["modelValue", "saving"]),
    _createVNode(DsAttendanceRevertModal, {
      modelValue: isRevertModalOpen.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((isRevertModalOpen).value = $event)),
      saving: isReverting.value,
      onConfirm: executeRevert
    }, null, 8, ["modelValue", "saving"]),
    _createVNode(DsAttendanceLegOverwriteModal, {
      "model-value": _unref(isLegOverwriteOpen),
      conflicts: _unref(legOverwriteConflicts),
      "effective-values": _unref(legOverwriteEffectiveValues),
      "effective-value-status": _unref(legOverwriteEffectiveValueStatus),
      submitting: _unref(isLegOverwriteSubmitting),
      "error-message": _unref(legOverwriteError),
      "stale-notice": _unref(legOverwriteStale),
      onConfirm: _unref(legOverwrite).confirm,
      onDecisionsChange: _unref(legOverwrite).refreshEffectiveValues,
      onCancel: _unref(legOverwrite).cancel
    }, null, 8, ["model-value", "conflicts", "effective-values", "effective-value-status", "submitting", "error-message", "stale-notice", "onConfirm", "onDecisionsChange", "onCancel"]),
    _createVNode(DsAttendanceAutoApprovalCriteriaModal, {
      modelValue: isAutoApprovalCriteriaModalOpen.value,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((isAutoApprovalCriteriaModalOpen).value = $event)),
      criteria: autoApprovalCriteria.value
    }, null, 8, ["modelValue", "criteria"]),
    _createVNode(DsAttendanceJustificationModal, {
      modelValue: isSubmitJustificationModalOpen.value,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((isSubmitJustificationModalOpen).value = $event)),
      saving: isProcessingJustification.value,
      title: "Enviar justificativa",
      description: "Descreva a justificativa para as divergências encontradas no registro.",
      placeholder: "Descreva a justificativa...",
      "confirm-label": "Enviar",
      "confirm-class": "bg-primary30",
      onConfirm: handleSubmitJustification
    }, null, 8, ["modelValue", "saving"]),
    _createVNode(DsAttendanceJustificationModal, {
      modelValue: isRejectJustificationModalOpen.value,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((isRejectJustificationModalOpen).value = $event)),
      saving: isProcessingJustification.value,
      title: "Rejeitar justificativa",
      description: "Informe o motivo da rejeição da justificativa enviada.",
      placeholder: "Motivo da rejeição...",
      "confirm-label": "Rejeitar",
      "confirm-class": "bg-negative",
      onConfirm: handleRejectJustification
    }, null, 8, ["modelValue", "saving"])
  ], 64))
}
}

})